var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _g, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewYearDiscount3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 310,
    viewBox: "0 0 260 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5084_26628)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.343 209.206C253.804 164.719 253.804 92.5916 209.343 48.1048C164.882 3.618 92.7971 3.61801 48.3364 48.1048C3.87559 92.5916 3.87559 164.719 48.3364 209.206C92.7971 253.693 164.882 253.693 209.343 209.206Z",
    fill: "#E7E3F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241.093 128.647C241.093 133.904 240.736 139.076 240.03 144.132C239.665 146.788 239.207 149.42 238.656 152.014C238.625 152.193 238.587 152.363 238.548 152.542C238.431 153.086 238.307 153.614 238.191 154.15C237.71 156.223 237.166 158.273 236.569 160.308C235.032 165.565 233.123 170.675 230.856 175.575C230.049 177.322 229.219 179.039 228.319 180.724C226.324 184.529 224.12 188.218 221.714 191.751C201.519 221.455 167.455 240.978 128.836 240.978C95.5944 240.978 65.737 226.518 45.1699 203.547C42.6397 200.705 40.2415 197.739 37.9908 194.648C34.9251 190.439 32.1466 185.989 29.6785 181.361C27.4744 177.229 25.5263 172.935 23.8576 168.501C23.7179 168.136 23.5782 167.771 23.4463 167.398C22.8332 165.744 22.2666 164.066 21.7388 162.366C21.5681 161.876 21.4129 161.379 21.2654 160.882C21.1723 160.572 21.0869 160.269 21.0015 159.951C18.1221 150.018 16.5776 139.503 16.5776 128.647C16.5776 66.6142 66.8391 16.3232 128.836 16.3232C190.832 16.3232 241.093 66.6142 241.093 128.647Z",
    fill: "#526D86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5795 168.251L134.703 160.788C135.347 160.718 135.759 160.066 135.534 159.453L131.063 147.408C130.993 147.214 130.854 147.043 130.683 146.927L120.26 140.023C119.274 139.37 120.042 137.856 121.152 138.26L126.678 140.295C127.47 140.59 128.246 139.813 127.951 139.013L124.311 129.221C124.257 129.081 124.179 128.957 124.07 128.856L114.012 119.094C113.267 118.372 113.996 117.129 114.99 117.432L117.054 118.061C118.024 118.356 118.754 117.184 118.071 116.438L109.704 107.368C108.944 106.545 109.922 105.287 110.907 105.822L114.47 107.756C115.277 108.191 116.193 107.399 115.874 106.537L112.126 96.4492C112.064 96.2939 111.971 96.1464 111.839 96.0376L107.128 92.015C106.289 91.3005 107.073 89.9493 108.105 90.3221C108.897 90.6094 109.665 89.8328 109.371 89.0407L100.073 64.004C99.7467 63.1342 98.5126 63.142 98.2022 64.0273L87.841 93.9098C87.5771 94.6709 88.2834 95.4164 89.0518 95.1912L90.1538 94.8728C91.0929 94.601 91.8147 95.6959 91.2016 96.457L83.9371 105.349C83.8673 105.442 83.8052 105.543 83.7664 105.652L78.3723 121.214C78.0774 122.061 78.97 122.829 79.7616 122.426L85.8464 119.296C86.8553 118.776 87.8022 120.073 87.0028 120.88C83.1921 124.709 77.7515 130.207 73.9795 134.152C73.8786 134.253 73.8088 134.377 73.7622 134.509L62.524 166.939C62.2834 167.622 62.8422 168.329 63.564 168.251H63.5795Z",
    fill: "#495464"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4326 174.829L88.2135 157.667C88.7257 157.512 88.9585 156.914 88.6791 156.456L83.1609 147.339C83.0678 147.191 82.9358 147.075 82.7728 147.005L73.2033 143.005C72.303 142.625 72.6911 141.274 73.6534 141.437L78.4732 142.237C79.1639 142.353 79.6761 141.6 79.3114 140.994L74.8254 133.586C74.7633 133.477 74.6779 133.391 74.577 133.322L64.86 126.938C64.1382 126.464 64.5418 125.338 65.3955 125.432L67.1806 125.618C68.0111 125.703 68.4302 124.639 67.7549 124.135L59.5281 118.046C58.783 117.495 59.3806 116.315 60.2654 116.602L63.4708 117.619C64.1926 117.852 64.8212 117.06 64.4254 116.408L59.8075 108.774C59.7376 108.658 59.629 108.557 59.5125 108.487L55.0499 105.94C54.2582 105.489 54.6851 104.27 55.5854 104.41C56.2761 104.518 56.7806 103.773 56.4158 103.167L44.9448 84.2188C44.5412 83.5588 43.54 83.7607 43.4236 84.5295L39.6361 110.49C39.543 111.15 40.226 111.647 40.8236 111.345L41.6696 110.91C42.3914 110.545 43.152 111.321 42.7639 112.036L38.2314 120.415C38.1848 120.5 38.1537 120.594 38.1382 120.687L36.1669 134.207C36.0582 134.945 36.9042 135.434 37.4863 134.976L41.9567 131.481C42.694 130.906 43.672 131.807 43.1442 132.592C40.6373 136.304 37.0594 141.631 34.5991 145.428C34.537 145.529 34.4982 145.638 34.4749 145.755L30.3693 173.929C30.2839 174.527 30.8427 175.008 31.4248 174.837L31.4326 174.829Z",
    fill: "#495464"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.08 169.036L230.329 171.824C230.864 171.847 231.283 171.358 231.175 170.838L229.017 160.401C228.978 160.23 228.893 160.074 228.761 159.958L221.077 152.992C220.356 152.332 221.17 151.19 222.024 151.664L226.301 154.025C226.914 154.367 227.643 153.823 227.504 153.14L225.75 144.652C225.726 144.535 225.672 144.419 225.602 144.318L218.57 135.053C218.05 134.362 218.803 133.438 219.579 133.811L221.194 134.587C221.954 134.952 222.699 134.083 222.234 133.384L216.514 124.903C215.994 124.135 216.948 123.226 217.693 123.785L220.371 125.812C220.976 126.27 221.83 125.734 221.675 124.989L219.867 116.252C219.836 116.113 219.773 115.988 219.68 115.88L216.32 111.989C215.722 111.298 216.529 110.288 217.336 110.723C217.95 111.057 218.679 110.521 218.532 109.83L214.038 88.1327C213.883 87.3794 212.866 87.2318 212.501 87.9152L200.27 111.119C199.959 111.709 200.44 112.408 201.108 112.323L202.055 112.199C202.854 112.09 203.312 113.084 202.714 113.628L195.652 120.011C195.582 120.073 195.52 120.151 195.473 120.236L189.101 132.32C188.752 132.98 189.388 133.718 190.087 133.485L195.465 131.683C196.358 131.388 196.971 132.568 196.218 133.127C192.617 135.791 187.464 139.619 183.886 142.376C183.793 142.446 183.715 142.539 183.661 142.64L170.389 167.825C170.11 168.36 170.474 169.005 171.08 169.028V169.036Z",
    fill: "#495464"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.424 172.258L37.5173 167.171L40.6451 154.894L55.0188 143.874L42.0421 149.403L44.8206 138.5L55.0732 126.712L47.1102 129.531L58.5657 114.667L49.4385 120.375L52.3955 108.765L59.5436 101.605L53.583 104.098L60.4284 77.2363L73.8941 107.717L68.5155 106.303L77.7203 116.383L84.8141 132.435L72.0857 126.378C72.4117 126.673 83.0212 136.279 89.0284 141.979L102.409 172.281L102.424 172.258Z",
    fill: "#787F88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2146 109.892C49.8964 110.715 50.0594 111.803 50.8123 112.268C51.5496 112.727 52.5042 112.439 53.2803 112.051C54.0487 111.663 54.8403 111.166 55.7018 111.228C57.4015 111.344 58.3096 113.488 59.9627 113.884C60.8087 114.086 61.709 113.767 62.3842 113.216C65.3723 110.754 66.6917 103.361 61.9108 102.165C60.0636 101.699 58.1311 102.383 56.6409 103.462C54.7006 104.86 51.0917 107.617 50.2224 109.892H50.2146Z",
    fill: "#B8BAC7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9304 126.985C44.9137 127.536 43.7263 128.569 44.2307 129.609C44.6887 130.541 46.0469 130.417 47.017 130.052C48.9728 129.322 50.7734 128.188 52.7448 127.513C54.7239 126.837 57.0445 126.674 58.7907 127.815C60.5448 128.957 61.577 131.279 63.6337 131.659C65.5818 132.024 67.4755 130.184 67.623 128.204C67.9257 124.197 62.7179 120.811 59.1089 120.725C54.8558 120.624 49.5394 125.028 45.9227 126.985H45.9304Z",
    fill: "#B8BAC7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5041 132.521C77.6349 131.814 76.7423 131.092 75.6946 130.719C74.639 130.339 73.374 130.37 72.5047 131.069C71.4492 131.915 71.2707 133.422 71.1698 134.773L70.7041 141.04C70.6188 142.174 70.5411 143.339 70.8671 144.434C71.1931 145.521 72.0313 146.538 73.1489 146.732C75.1047 147.074 76.8044 144.923 78.7758 145.14C79.8546 145.257 80.7161 146.057 81.4456 146.864C82.1752 147.672 82.8892 148.557 83.9059 148.946C86.4128 149.909 86.0713 147.726 86.6999 146.398C87.5071 144.674 89.3465 144.356 88.7101 142.057C87.6546 138.237 81.399 134.897 78.5041 132.537V132.521Z",
    fill: "#B8BAC7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8516 137.282C44.285 137.724 43.7029 138.198 43.3614 138.835C43.0199 139.472 42.9811 140.326 43.4546 140.869C43.9435 141.436 44.7895 141.499 45.5423 141.514C46.9548 141.553 48.3674 141.584 49.7877 141.623C51.2235 141.662 52.6826 141.693 54.0719 141.335C55.4611 140.97 56.7961 140.155 57.448 138.874C58.2164 137.367 57.8904 135.457 56.9358 134.059C55.5077 131.962 53.9555 131.007 51.8289 132.265C49.3919 133.709 47.0946 135.527 44.8593 137.274L44.8516 137.282Z",
    fill: "#B8BAC7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6673 154.731C38.9765 155.36 38.2935 156.502 39.0153 157.084C39.4422 157.434 40.0786 157.271 40.5986 157.092C43.09 156.246 45.5813 155.391 48.0726 154.545C49.8655 153.931 51.6506 153.326 53.4046 152.611C55.5079 151.757 58.6667 150.204 58.6356 147.494C58.6123 145.389 56.5479 144.62 54.724 144.714C52.0231 144.846 49.6094 146.966 47.5061 148.449C44.7664 150.383 42.1509 152.472 39.6673 154.724V154.731Z",
    fill: "#B8BAC7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7286 79.2252C58.9847 78.1302 59.4038 76.8489 60.4826 76.5382C61.2277 76.3208 62.0504 76.6858 62.5859 77.2527C63.1214 77.8196 63.4241 78.5573 63.719 79.2795C65.1859 82.8673 66.6528 86.4551 68.1196 90.0428C68.4766 90.9048 68.8337 91.8367 68.6552 92.7531C68.4766 93.6694 67.5143 94.4926 66.6372 94.1587C65.6904 93.7937 65.5584 92.4658 64.7746 91.8212C62.0737 89.5769 58.7984 96.7602 56.4546 92.093C55.5698 90.3379 56.6796 87.9306 57.091 86.1677C57.6343 83.8535 58.1698 81.5394 58.7131 79.2329L58.7286 79.2252Z",
    fill: "#B8BAC7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M196.917 159.476L128.153 148.93C127.532 148.837 127.144 148.2 127.345 147.602L131.335 135.705C131.405 135.488 131.552 135.301 131.738 135.177L141.564 128.739C142.565 128.087 141.812 126.534 140.679 126.922L135.402 128.724C134.602 128.996 133.842 128.235 134.105 127.435L137.357 117.743C137.412 117.596 137.489 117.456 137.606 117.347L147.043 107.997C147.788 107.259 147.067 106.017 146.058 106.289L144.048 106.84C143.07 107.104 142.348 105.931 143.023 105.178L150.877 96.4106C151.638 95.5642 150.652 94.2984 149.643 94.8264L146.306 96.5815C145.491 97.0086 144.575 96.2242 144.87 95.3545L148.208 85.3833C148.262 85.2124 148.371 85.0571 148.51 84.9329L152.926 81.1199C153.772 80.3899 152.996 79.0309 151.941 79.3804C151.141 79.6444 150.388 78.8834 150.652 78.0913L158.871 53.5515C159.182 52.6352 160.47 52.6196 160.796 53.536L171.545 83.7137C171.833 84.5213 171.064 85.2979 170.257 85.0183L169.667 84.8164C168.705 84.4825 167.905 85.6085 168.534 86.4084L175.69 95.5098C175.76 95.5952 175.814 95.6962 175.845 95.7971L181.425 111.461C181.744 112.354 180.781 113.154 179.966 112.688L174.689 109.682C173.672 109.1 172.64 110.412 173.447 111.266C177.219 115.258 182.458 120.834 186.113 124.849C186.206 124.95 186.268 125.066 186.315 125.19L198.042 158.133C198.298 158.863 197.693 159.6 196.932 159.484L196.917 159.476Z",
    fill: "#495464"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M168.169 182.44L92.7537 176.67L97.4802 162.746L115.238 150.251L99.5913 156.518L103.79 144.163L116.806 130.798L107.252 133.99L121.936 117.138L110.775 123.607L115.246 110.444L124.225 102.329L117.046 105.148L127.392 74.6982L140.469 109.248L134.307 107.64L144.187 119.072L151.071 137.267L136.721 130.402C137.078 130.744 148.634 141.631 155.161 148.092L168.161 182.44H168.169Z",
    fill: "#787F88"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.021 86.3468C121.625 87.4573 121.346 88.9638 122.347 89.5929C123.123 90.0821 124.148 89.6472 124.901 89.1192C125.653 88.5911 126.437 87.9388 127.353 88.0009C128.517 88.0863 129.239 89.2667 129.837 90.2685C130.434 91.2703 131.404 92.3575 132.545 92.109C133.314 91.9381 133.834 91.1771 133.966 90.4083C134.098 89.6317 133.911 88.8474 133.717 88.0863C132.856 84.7393 131.024 75.467 127.213 74.1623C124.908 73.3702 122.968 83.6987 122.021 86.3468Z",
    fill: "#B8BAC7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M114.392 109.085C113.624 109.621 112.809 110.203 112.459 111.073C112.11 111.943 112.459 113.162 113.367 113.379C114.252 113.589 115.122 112.789 116.022 112.929C117.046 113.092 117.504 114.327 118.404 114.839C119.336 115.368 120.57 114.979 121.33 114.226C122.091 113.473 122.479 112.432 122.852 111.43C123.224 110.429 123.612 109.388 124.373 108.635C125.584 107.415 127.586 107.081 128.51 105.637C129.239 104.495 128.983 102.834 127.951 101.956C125.77 100.108 123.667 102.647 121.967 103.828C119.444 105.583 116.922 107.338 114.4 109.093L114.392 109.085Z",
    fill: "#B8BAC7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.852 142.027C102.905 142.726 101.842 143.798 102.285 144.893C102.533 145.499 103.2 145.848 103.86 145.879C104.52 145.91 105.148 145.669 105.738 145.39C107.5 144.543 109.223 143.208 111.163 143.433C112.599 143.596 113.872 144.621 115.316 144.582C116.728 144.543 117.931 143.479 118.645 142.26C119.367 141.041 119.732 139.651 120.322 138.362C120.958 136.972 122.207 135.543 123.713 135.791C124.497 135.923 125.157 136.506 125.948 136.591C127.058 136.716 128.09 135.745 128.285 134.642C128.486 133.547 128.005 132.413 127.276 131.567C125.172 129.128 121.315 128.919 118.366 130.208C115.416 131.497 113.158 133.943 111 136.327L103.852 142.02V142.027Z",
    fill: "#B8BAC7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.247 122.698C117.046 122.271 118.117 121.937 118.792 122.543C119.25 122.955 119.32 123.677 119.103 124.252C118.893 124.826 118.451 125.292 118.009 125.711C116.185 127.443 114.012 128.81 111.66 129.711C109.153 130.666 109.984 127.637 111.039 126.628C112.622 125.113 114.307 123.731 116.255 122.698H116.247Z",
    fill: "#B8BAC7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M150.854 140.87C151.591 141.476 152.398 142.26 152.266 143.2C152.15 144.03 151.281 144.597 150.443 144.644C149.604 144.691 148.797 144.333 148.06 143.937C147.315 143.541 146.577 143.099 145.755 142.943C143.946 142.602 142.216 143.697 140.446 144.201C138.141 144.861 135.681 144.512 133.314 144.155C132.421 144.023 131.513 143.883 130.714 143.456C129.922 143.029 129.255 142.244 129.216 141.344C129.146 139.534 131.397 138.509 131.948 136.785C132.235 135.876 132.01 134.89 131.715 133.982C131.42 133.073 131.047 132.172 131.04 131.217C131.04 130.262 131.497 129.229 132.398 128.911C134.113 128.313 136.853 130.231 138.304 131.007C139.468 131.629 140.578 132.312 141.595 133.143C144.707 135.682 147.749 138.307 150.854 140.862V140.87Z",
    fill: "#B8BAC7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M151.188 180.436L225.136 172.678L220.107 159.127L202.311 147.346L217.856 153.069L213.386 141.04L200.231 128.273L209.707 131.147L194.813 114.994L205.958 121.043L201.201 108.238L192.151 100.511L199.284 103.081L188.278 73.4473L176.381 107.756L182.388 106.009L172.997 117.51L166.733 135.581L180.641 128.436C180.3 128.778 169.248 139.798 163.008 146.329L151.188 180.436Z",
    fill: "#787F88"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M186.517 75.4044L183.195 83.939C182.962 84.5292 182.729 85.1427 182.791 85.7717C182.854 86.4007 183.304 87.0375 183.932 87.0841C184.584 87.1307 185.12 86.556 185.376 85.9581C185.632 85.3601 185.733 84.6845 186.074 84.1331C186.416 83.5818 187.161 83.1702 187.728 83.4963C188.294 83.8147 188.418 84.7 189.039 84.8942C189.412 85.0106 189.823 84.8087 190.071 84.5059C190.32 84.203 190.436 83.8147 190.545 83.442C190.894 82.2616 191.236 81.0734 191.36 79.8542C191.631 77.1517 188.527 70.2402 186.517 75.4044Z",
    fill: "#B8BAC7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M200.161 101.637C200.549 102.181 200.906 102.887 200.588 103.478C200.223 104.161 199.206 104.145 198.539 103.765C197.871 103.377 197.375 102.74 196.699 102.367C195.015 101.435 192.57 102.437 191.134 100.961C190.094 99.8898 190.358 98.4143 191.546 97.6455C194.736 95.5721 198.477 99.2919 200.153 101.645L200.161 101.637Z",
    fill: "#B8BAC7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M174.704 106.374C174.215 106.777 173.695 107.391 173.959 107.973C174.246 108.61 175.154 108.556 175.829 108.4C177.452 108.02 179.066 107.639 180.688 107.267C182.093 106.94 183.684 106.436 183.963 104.813C184.173 103.632 183.614 102.607 182.442 102.405C179.982 101.986 176.396 104.968 174.704 106.381V106.374Z",
    fill: "#B8BAC7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M171.429 117.751C171.002 118.325 170.591 119.117 170.994 119.708C171.413 120.329 172.399 120.174 173.012 119.747C173.625 119.319 174.122 118.683 174.836 118.457C175.636 118.201 176.505 118.52 177.219 118.954C177.933 119.389 178.585 119.948 179.369 120.236C180.153 120.531 181.146 120.484 181.689 119.847C182.271 119.156 182.093 118.069 182.566 117.293C183.21 116.236 184.809 116.205 185.896 116.796C186.982 117.386 187.759 118.411 188.713 119.203C189.171 119.583 189.683 119.925 190.265 120.034C190.847 120.143 191.515 119.979 191.872 119.514C192.237 119.04 192.229 118.356 191.996 117.805C191.763 117.254 191.36 116.803 190.948 116.361C189.52 114.808 188.053 113.216 186.183 112.245C180.409 109.232 174.821 113.223 171.429 117.751Z",
    fill: "#B8BAC7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M205.927 118.24C206.23 118.605 206.517 119.009 206.61 119.475C206.704 119.941 206.541 120.492 206.114 120.702C205.718 120.904 205.245 120.764 204.818 120.617C202.621 119.863 200.425 119.118 198.221 118.365C197.157 118 196.063 117.627 195.194 116.912C194.317 116.206 193.696 115.08 193.89 113.969C194.813 108.65 204.523 116.516 205.92 118.233L205.927 118.24Z",
    fill: "#B8BAC7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M213.797 139.316C214.558 139.945 215.396 140.923 214.907 141.785C214.535 142.445 213.634 142.515 212.881 142.5C210.669 142.469 208.458 142.445 206.246 142.414C204.934 142.399 203.537 142.36 202.427 141.653C201.379 140.985 200.673 139.774 199.486 139.432C198.314 139.091 197.049 139.712 195.853 139.479C194.681 139.246 193.789 138.213 193.409 137.079C193.028 135.946 193.083 134.711 193.184 133.523C193.323 131.845 193.595 130.098 194.549 128.708C195.411 127.45 197.305 126.277 198.849 126.93C200.269 127.527 201.643 129.29 202.823 130.261C206.478 133.282 210.134 136.303 213.797 139.316Z",
    fill: "#B8BAC7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M163.528 142.594C162.946 143.207 162.356 143.844 162.038 144.628C161.72 145.413 161.712 146.376 162.24 147.036C162.736 147.657 163.606 147.874 164.39 147.789C165.181 147.703 165.911 147.362 166.633 147.028C169.489 145.684 172.337 144.341 175.193 142.997C176.598 142.337 178.026 141.67 179.547 141.374C180.851 141.126 182.248 141.141 183.405 140.505C184.6 139.845 185.36 138.563 185.694 137.235C186.028 135.907 185.997 134.517 185.966 133.15C185.919 131.24 185.88 128.646 184.219 127.334C182.853 126.255 181.27 127.163 180.036 128.002C176.194 130.611 172.624 133.795 169.225 136.948C167.261 138.765 165.36 140.652 163.52 142.594H163.528Z",
    fill: "#B8BAC7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M183.598 95.9675C183.808 96.1849 184.142 96.2082 184.437 96.216C185.221 96.247 185.997 96.2703 186.781 96.3014C186.843 96.3014 186.905 96.3014 186.967 96.3014C187.533 96.3247 188.108 96.3402 188.659 96.2005C189.21 96.0607 189.738 95.7345 189.994 95.2297C190.979 93.2728 188.674 92.2943 187.138 92.4496C186.144 92.5506 182.101 94.4066 183.598 95.9597V95.9675Z",
    fill: "#B8BAC7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M240.03 144.131C239.665 146.787 239.207 149.419 238.656 152.013C238.625 152.192 238.587 152.363 238.548 152.541C238.431 153.085 238.307 153.613 238.191 154.149C237.71 156.222 237.166 158.272 236.569 160.307C235.032 165.564 233.123 170.674 230.856 175.574C230.049 177.322 229.219 179.038 228.319 180.723C227.83 181.647 227.333 182.571 226.821 183.488C225.4 186.019 223.887 188.497 222.273 190.904C222.094 191.191 221.908 191.471 221.714 191.75C221.341 192.302 220.961 192.845 220.588 193.381C200.262 222.169 166.741 240.977 128.836 240.977C96.4248 240.977 67.2349 227.232 46.7376 205.255C46.2021 204.688 45.6821 204.121 45.1699 203.547C43.703 201.9 42.2749 200.207 40.9167 198.475C40.1794 197.559 39.4654 196.635 38.7747 195.695C38.503 195.346 38.2469 194.996 37.9908 194.647C34.9251 190.438 32.1466 185.988 29.6785 181.36C27.4743 177.228 25.5263 172.934 23.8576 168.5C23.7179 168.135 23.5782 167.77 23.4463 167.397C25.8057 166.457 28.4445 165.704 31.3394 165.005C41.6308 162.52 51.9609 161.612 62.5317 162.171C77.5185 162.955 92.2803 165.999 107.197 167.638C152.499 172.623 199.167 164.298 240.03 144.131Z",
    fill: "#E0DBED"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8648 202.499C94.9269 202.832 95.2839 203.034 95.6098 203.135C96.5722 203.446 97.651 203.368 98.5591 202.926C98.7609 202.832 98.9549 202.708 99.0946 202.545C99.2343 202.374 99.3197 202.149 99.2731 201.932C99.2266 201.722 99.0636 201.551 98.8695 201.458C98.6755 201.365 98.4582 201.326 98.2486 201.303C97.5734 201.233 94.6086 201.124 94.8725 202.499H94.8648Z",
    fill: "#D1CAE5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M118.521 174.93C118.56 175.217 118.847 175.396 119.111 175.497C119.902 175.8 120.803 175.784 121.579 175.45C121.75 175.381 121.913 175.287 122.045 175.155C122.169 175.023 122.254 174.829 122.223 174.651C122.192 174.472 122.06 174.324 121.905 174.239C121.75 174.146 121.571 174.115 121.393 174.084C120.834 173.998 118.366 173.773 118.521 174.93Z",
    fill: "#D1CAE5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M154.16 203.143C154.184 203.431 154.463 203.617 154.727 203.733C155.503 204.067 156.403 204.098 157.195 203.803C157.366 203.741 157.537 203.656 157.669 203.532C157.8 203.4 157.886 203.221 157.863 203.035C157.839 202.856 157.715 202.701 157.568 202.607C157.42 202.514 157.242 202.468 157.063 202.429C156.504 202.32 154.052 201.986 154.16 203.143Z",
    fill: "#D1CAE5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M134.951 185.732C135.107 185.709 135.27 185.67 135.409 185.585C135.549 185.499 135.658 185.36 135.665 185.197C135.689 184.886 135.363 184.668 135.068 184.56C134.253 184.249 133.143 184.071 132.289 184.35C131.156 184.715 132.825 185.507 133.275 185.631C133.818 185.787 134.4 185.826 134.959 185.732H134.951Z",
    fill: "#D1CAE5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M195.031 190.236C195.186 190.213 195.349 190.174 195.489 190.089C195.628 190.003 195.737 189.864 195.745 189.7C195.768 189.39 195.442 189.172 195.147 189.064C194.332 188.753 193.222 188.574 192.369 188.854C191.236 189.219 192.904 190.011 193.354 190.135C193.898 190.291 194.48 190.329 195.038 190.236H195.031Z",
    fill: "#D1CAE5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M166.881 177.189C167.137 177.259 167.424 177.283 167.673 177.189C167.82 177.135 167.96 177.026 168.053 176.894C168.115 176.809 168.154 176.708 168.162 176.599C168.224 175.862 167.323 175.722 166.897 176.141C166.633 176.405 166.369 177.042 166.889 177.189H166.881Z",
    fill: "#D1CAE5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M116.713 184.816C116.969 184.886 117.256 184.91 117.504 184.816C117.652 184.762 117.791 184.653 117.885 184.521C117.947 184.436 117.985 184.335 117.993 184.226C118.055 183.496 117.155 183.349 116.728 183.768C116.464 184.032 116.2 184.669 116.72 184.816H116.713Z",
    fill: "#D1CAE5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M227.605 164.804C227.861 164.874 228.148 164.897 228.396 164.804C228.544 164.749 228.683 164.641 228.777 164.509C228.839 164.423 228.877 164.322 228.885 164.213C228.947 163.484 228.047 163.336 227.62 163.755C227.356 164.019 227.092 164.656 227.612 164.804H227.605Z",
    fill: "#D1CAE5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6755 177.858C85.9316 177.928 86.2187 177.952 86.4671 177.858C86.6146 177.804 86.7543 177.695 86.8474 177.563C86.9095 177.478 86.9483 177.377 86.956 177.268C87.0181 176.538 86.1178 176.391 85.691 176.81C85.4271 177.074 85.1632 177.711 85.6832 177.858H85.6755Z",
    fill: "#D1CAE5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2983 169.23C81.5544 169.3 81.8415 169.324 82.0899 169.23C82.2374 169.176 82.3771 169.067 82.4702 168.935C82.5323 168.85 82.5711 168.749 82.5788 168.64C82.6409 167.91 81.7406 167.763 81.3138 168.182C81.0499 168.446 80.786 169.083 81.306 169.23H81.2983Z",
    fill: "#D1CAE5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M163.373 200.309C163.629 200.378 163.916 200.402 164.165 200.309C164.312 200.254 164.452 200.145 164.545 200.013C164.607 199.928 164.646 199.827 164.654 199.718C164.716 198.988 163.815 198.841 163.388 199.26C163.125 199.524 162.861 200.161 163.381 200.309H163.373Z",
    fill: "#D1CAE5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M151.716 185.771C151.886 185.919 152.096 186.027 152.313 186.051C152.445 186.058 152.585 186.027 152.701 185.965C152.779 185.919 152.841 185.857 152.887 185.779C153.198 185.243 152.561 184.824 152.088 184.987C151.793 185.088 151.374 185.484 151.708 185.771H151.716Z",
    fill: "#D1CAE5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5724 187.542C96.8285 187.612 97.1157 187.635 97.3641 187.542C97.5115 187.488 97.6512 187.379 97.7444 187.247C97.8065 187.161 97.8453 187.06 97.853 186.952C97.9151 186.222 97.0148 186.074 96.5879 186.494C96.3241 186.758 96.0602 187.394 96.5802 187.542H96.5724Z",
    fill: "#E5D6CA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M182.217 186.105C182.388 186.253 182.597 186.361 182.815 186.385C182.947 186.392 183.086 186.361 183.203 186.299C183.28 186.253 183.342 186.191 183.389 186.113C183.699 185.577 183.063 185.158 182.59 185.321C182.295 185.422 181.876 185.818 182.209 186.105H182.217Z",
    fill: "#D1CAE5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M207.736 186.656C207.907 186.803 208.116 186.912 208.334 186.935C208.466 186.943 208.605 186.912 208.722 186.85C208.799 186.803 208.861 186.741 208.908 186.664C209.218 186.128 208.582 185.709 208.109 185.872C207.814 185.98 207.395 186.369 207.728 186.656H207.736Z",
    fill: "#D1CAE5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1089 186.797C46.6522 186.991 47.273 186.936 47.7775 186.665C48.088 186.494 48.3674 186.222 48.4062 185.872C48.445 185.562 48.282 185.251 48.0414 185.057C47.8008 184.863 47.4904 184.77 47.1799 184.731C46.5668 184.653 45.5656 184.777 45.193 185.344C44.7662 185.997 45.5656 186.602 46.1166 186.797H46.1089Z",
    fill: "#D1CAE5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M126.802 200.829C127.361 200.938 127.974 200.806 128.432 200.456C128.711 200.247 128.952 199.928 128.937 199.579C128.929 199.268 128.719 198.981 128.455 198.826C128.191 198.67 127.865 198.616 127.555 198.624C126.934 198.639 125.964 198.896 125.677 199.517C125.351 200.224 126.228 200.705 126.794 200.821L126.802 200.829Z",
    fill: "#D1CAE5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M103.557 174.224C103.969 174.464 104.489 174.519 104.947 174.379C105.226 174.286 105.498 174.107 105.583 173.828C105.661 173.579 105.583 173.299 105.412 173.105C105.241 172.903 105.009 172.779 104.76 172.701C104.271 172.546 103.433 172.484 103.037 172.896C102.587 173.362 103.146 173.983 103.565 174.231L103.557 174.224Z",
    fill: "#D1CAE5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1043 173.719C42.5699 173.665 43.1055 173.486 43.2296 173.036C43.3073 172.757 43.1831 172.454 42.9735 172.252C42.469 171.755 41.6308 171.685 40.9634 171.607C40.3425 171.53 39.6905 171.429 39.0619 171.522C38.604 171.592 38.2081 171.786 38.2547 172.306C38.3168 173.052 39.0929 173.323 39.7061 173.502C40.4822 173.727 41.2971 173.805 42.0965 173.712L42.1043 173.719Z",
    fill: "#D1CAE5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9297 167.731C52.3644 167.918 52.9464 167.91 53.4975 167.794C53.9321 167.7 54.4056 167.514 54.6384 167.188C55.3602 166.186 53.5674 165.751 52.7059 165.759C51.2856 165.759 50.9674 167.32 51.9297 167.731Z",
    fill: "#D1CAE5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M64.767 187.184C65.0464 187.115 65.3025 186.99 65.45 186.827C65.675 186.587 65.6362 186.284 65.4422 186.043C64.9921 185.492 63.8279 185.297 62.9741 185.725C62.2524 186.09 62.5395 186.711 63.1371 187.029C63.564 187.254 64.2237 187.316 64.767 187.177V187.184Z",
    fill: "#D1CAE5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5652 200.65C77.93 200.611 78.3336 200.487 78.4888 200.153C78.6518 199.788 78.4189 199.353 78.1085 199.105C77.4488 198.585 75.9742 198.577 75.4309 199.33C74.5849 200.51 76.921 200.728 77.5652 200.65Z",
    fill: "#D1CAE5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M233.689 153.87C234.023 153.714 234.365 153.466 234.403 153.101C234.442 152.705 234.085 152.363 233.705 152.231C232.913 151.952 231.508 152.41 231.237 153.295C230.81 154.685 233.099 154.141 233.682 153.87H233.689Z",
    fill: "#D1CAE5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M223.134 156.09C223.227 156.238 223.437 156.269 223.623 156.253C224.151 156.215 224.663 155.966 225.012 155.578C225.09 155.492 225.16 155.399 225.198 155.291C225.237 155.182 225.229 155.05 225.167 154.957C225.105 154.863 224.989 154.817 224.88 154.801C224.772 154.794 224.655 154.817 224.547 154.848C224.205 154.949 222.746 155.477 223.142 156.09H223.134Z",
    fill: "#D1CAE5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8901 184.746C76.8901 184.924 77.0454 185.064 77.2006 185.157C77.6585 185.429 78.2173 185.507 78.7295 185.382C78.8382 185.359 78.9546 185.32 79.0477 185.25C79.1409 185.181 79.2107 185.072 79.2107 184.955C79.2107 184.847 79.1486 184.738 79.0555 184.668C78.9701 184.598 78.8615 184.551 78.7528 184.52C78.4191 184.412 76.9134 184.016 76.8901 184.746Z",
    fill: "#D1CAE5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M161.541 192.97C161.557 193.149 161.728 193.273 161.898 193.343C162.38 193.552 162.954 193.568 163.443 193.389C163.551 193.351 163.66 193.296 163.738 193.219C163.823 193.141 163.877 193.024 163.862 192.908C163.846 192.799 163.769 192.698 163.676 192.636C163.583 192.574 163.466 192.543 163.357 192.527C163.008 192.458 161.471 192.248 161.534 192.978L161.541 192.97Z",
    fill: "#D1CAE5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6875 180.156C69.8427 180.156 70.0057 180.141 70.1687 180.094C70.3317 180.047 70.4869 179.954 70.5645 179.83C70.712 179.597 70.6111 178.906 70.3938 178.789C69.7729 178.463 68.8338 178.207 67.9335 178.324C66.746 178.471 67.8403 179.752 68.1973 179.9C68.632 180.079 69.152 180.172 69.6953 180.164L69.6875 180.156Z",
    fill: "#D1CAE5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M111.016 201.179C111.295 201.28 111.621 201.256 111.885 201.109C112.048 201.023 112.196 200.876 112.211 200.689C112.227 200.526 112.141 200.363 112.017 200.262C111.893 200.161 111.73 200.115 111.567 200.091C111.249 200.053 110.721 200.115 110.527 200.418C110.302 200.759 110.721 201.078 111.008 201.179H111.016Z",
    fill: "#D1CAE5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M113.391 192.963C113.561 192.885 113.748 192.753 113.763 192.559C113.787 192.349 113.6 192.171 113.399 192.101C112.979 191.953 112.25 192.194 112.11 192.66C111.885 193.382 113.088 193.103 113.391 192.963Z",
    fill: "#E5D6CA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M130.388 191.251C178.396 191.251 217.313 188.625 217.313 185.385C217.313 182.146 178.396 179.52 130.388 179.52C82.3805 179.52 43.4626 182.146 43.4626 185.385C43.4626 188.625 82.3805 191.251 130.388 191.251Z",
    fill: "#B8B8C7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3466 193.731C37.5639 194.034 37.7735 194.345 37.9908 194.648C38.2469 194.997 38.5031 195.347 38.7747 195.696C39.4654 196.636 40.1795 197.56 40.9168 198.476C42.275 200.208 43.703 201.901 45.1699 203.547C45.6821 204.122 46.2022 204.689 46.7377 205.256C67.2117 227.202 96.355 240.939 128.711 240.978C131.211 240.978 133.686 240.893 136.147 240.745C137.171 240.683 138.196 240.598 139.205 240.504C139.267 240.504 139.329 240.497 139.391 240.489C172.919 237.359 202.171 219.467 220.581 193.382C220.953 192.846 221.333 192.303 221.706 191.751C221.9 191.472 222.086 191.192 222.265 190.905C222.715 190.237 223.142 189.546 223.576 188.862C160.121 217.021 94.5389 212.796 37.3389 193.731H37.3466Z",
    fill: "#B8B8C7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M208.302 182.035H215.637C220.883 165.502 214.1 175.108 213.184 181.305C214.465 162.559 208.597 169.533 208.302 182.035Z",
    fill: "#5F6B7A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6781 180.436H54.3437C49.0273 164.385 55.8106 173.991 56.7264 180.188C55.4458 161.441 61.3133 168.415 61.6781 180.436Z",
    fill: "#5F6B7A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M140.271 71.0326L138.795 72.5098L140.271 73.9869L141.747 72.5098L140.271 71.0326Z",
    fill: "#DBDBED"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M107.094 111.305L105.617 112.782L107.094 114.259L108.57 112.782L107.094 111.305Z",
    fill: "#DBDBED"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5661 74.9985L90.0898 76.4756L91.5661 77.9527L93.0424 76.4756L91.5661 74.9985Z",
    fill: "#DBDBED"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M174.933 111.749L173.457 113.227L174.933 114.704L176.409 113.227L174.933 111.749Z",
    fill: "#DBDBED"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M184.752 88.4613L183.276 89.9385L184.752 91.4156L186.228 89.9385L184.752 88.4613Z",
    fill: "#DBDBED"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M128.835 32.5043L127.359 33.9814L128.835 35.4586L130.311 33.9814L128.835 32.5043Z",
    fill: "#DBDBED"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1389 110.314L55.6626 111.791L57.1389 113.268L58.6151 111.791L57.1389 110.314Z",
    fill: "#DBDBED"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6411 146.971L40.1648 148.448L41.6411 149.925L43.1173 148.448L41.6411 146.971Z",
    fill: "#DBDBED"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M150.657 93.2279L148.846 95.04L150.657 96.8521L152.468 95.04L150.657 93.2279Z",
    fill: "#DBDBED"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M150.66 98.4222C150.357 98.4222 150.109 98.1737 150.109 97.8708V92.2096C150.109 91.9067 150.357 91.6582 150.66 91.6582C150.963 91.6582 151.211 91.9067 151.211 92.2096V97.8708C151.211 98.1737 150.963 98.4222 150.66 98.4222Z",
    fill: "#DBDBED"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M153.485 95.5871H147.827C147.525 95.5871 147.276 95.3386 147.276 95.0357C147.276 94.7329 147.525 94.4844 147.827 94.4844H153.485C153.788 94.4844 154.036 94.7329 154.036 95.0357C154.036 95.3386 153.788 95.5871 153.485 95.5871Z",
    fill: "#DBDBED"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M110.618 56.3793L108.807 58.1914L110.618 60.0035L112.429 58.1914L110.618 56.3793Z",
    fill: "#DBDBED"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M110.62 61.5735C110.317 61.5735 110.069 61.325 110.069 61.0222V55.3609C110.069 55.0581 110.317 54.8096 110.62 54.8096C110.923 54.8096 111.171 55.0581 111.171 55.3609V61.0222C111.171 61.325 110.923 61.5735 110.62 61.5735Z",
    fill: "#DBDBED"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M113.445 58.7385H107.787C107.485 58.7385 107.236 58.49 107.236 58.1871C107.236 57.8842 107.485 57.6357 107.787 57.6357H113.445C113.748 57.6357 113.996 57.8842 113.996 58.1871C113.996 58.49 113.748 58.7385 113.445 58.7385Z",
    fill: "#DBDBED"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2358 83.7611L51.4248 85.5732L53.2358 87.3853L55.0469 85.5732L53.2358 83.7611Z",
    fill: "#DBDBED"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2417 88.9475C52.939 88.9475 52.6907 88.699 52.6907 88.3962V82.735C52.6907 82.4321 52.939 82.1836 53.2417 82.1836C53.5444 82.1836 53.7928 82.4321 53.7928 82.735V88.3962C53.7928 88.699 53.5444 88.9475 53.2417 88.9475Z",
    fill: "#DBDBED"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0744 86.1213H50.4165C50.1138 86.1213 49.8655 85.8728 49.8655 85.5699C49.8655 85.2671 50.1138 85.0186 50.4165 85.0186H56.0744C56.3771 85.0186 56.6255 85.2671 56.6255 85.5699C56.6255 85.8728 56.3771 86.1213 56.0744 86.1213Z",
    fill: "#DBDBED"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M206.655 121.087L204.844 122.899L206.655 124.712L208.466 122.899L206.655 121.087Z",
    fill: "#DBDBED"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M206.665 126.278C206.362 126.278 206.114 126.029 206.114 125.726V120.065C206.114 119.762 206.362 119.514 206.665 119.514C206.967 119.514 207.216 119.762 207.216 120.065V125.726C207.216 126.029 206.967 126.278 206.665 126.278Z",
    fill: "#DBDBED"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M209.49 123.451H203.832C203.529 123.451 203.281 123.203 203.281 122.9C203.281 122.597 203.529 122.349 203.832 122.349H209.49C209.793 122.349 210.041 122.597 210.041 122.9C210.041 123.203 209.793 123.451 209.49 123.451Z",
    fill: "#DBDBED"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M173.994 59.7602L172.183 61.5723L173.994 63.3844L175.805 61.5723L173.994 59.7602Z",
    fill: "#DBDBED"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M174.006 64.9515C173.703 64.9515 173.455 64.7029 173.455 64.4001V58.7389C173.455 58.436 173.703 58.1875 174.006 58.1875C174.309 58.1875 174.557 58.436 174.557 58.7389V64.4001C174.557 64.7029 174.309 64.9515 174.006 64.9515Z",
    fill: "#DBDBED"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M176.831 62.1164H171.173C170.87 62.1164 170.622 61.8679 170.622 61.565C170.622 61.2622 170.87 61.0137 171.173 61.0137H176.831C177.134 61.0137 177.382 61.2622 177.382 61.565C177.382 61.8679 177.134 62.1164 176.831 62.1164Z",
    fill: "#DBDBED"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0523 121.632L31.2412 123.444L33.0523 125.256L34.8633 123.444L33.0523 121.632Z",
    fill: "#DBDBED"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0625 126.829C32.7598 126.829 32.5115 126.581 32.5115 126.278V120.617C32.5115 120.314 32.7598 120.065 33.0625 120.065C33.3652 120.065 33.6136 120.314 33.6136 120.617V126.278C33.6136 126.581 33.3652 126.829 33.0625 126.829Z",
    fill: "#DBDBED"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8877 123.994H30.2298C29.9271 123.994 29.6787 123.746 29.6787 123.443C29.6787 123.14 29.9271 122.892 30.2298 122.892H35.8877C36.1904 122.892 36.4387 123.14 36.4387 123.443C36.4387 123.746 36.1904 123.994 35.8877 123.994Z",
    fill: "#DBDBED"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M133.702 97.2178C132.701 97.2178 132.701 98.7709 133.702 98.7709C134.703 98.7709 134.703 97.2178 133.702 97.2178Z",
    fill: "#DBDBED"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M153.136 118.31C152.135 118.31 152.135 119.863 153.136 119.863C154.137 119.863 154.137 118.31 153.136 118.31Z",
    fill: "#DBDBED"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M167.37 84.8945C166.369 84.8945 166.369 86.4477 167.37 86.4477C168.371 86.4477 168.371 84.8945 167.37 84.8945Z",
    fill: "#DBDBED"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M158.615 48.4648C157.614 48.4648 157.614 50.018 158.615 50.018C159.617 50.018 159.617 48.4648 158.615 48.4648Z",
    fill: "#DBDBED"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M128.502 60.5176C127.501 60.5176 127.501 62.0707 128.502 62.0707C129.503 62.0707 129.503 60.5176 128.502 60.5176Z",
    fill: "#DBDBED"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M106.328 29.835C105.327 29.835 105.327 31.3881 106.328 31.3881C107.329 31.3881 107.329 29.835 106.328 29.835Z",
    fill: "#DBDBED"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6864 61.8838C54.6852 61.8838 54.6852 63.4369 55.6864 63.4369C56.6876 63.4369 56.6876 61.8838 55.6864 61.8838Z",
    fill: "#DBDBED"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0942 49.5605C91.093 49.5605 91.093 51.1137 92.0942 51.1137C93.0954 51.1137 93.0954 49.5605 92.0942 49.5605Z",
    fill: "#DBDBED"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M201.046 53.668C200.045 53.668 200.045 55.2211 201.046 55.2211C202.047 55.2211 202.047 53.668 201.046 53.668Z",
    fill: "#DBDBED"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M209.529 93.1104C208.528 93.1104 208.528 94.6635 209.529 94.6635C210.53 94.6635 210.53 93.1104 209.529 93.1104Z",
    fill: "#DBDBED"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M226.774 125.159C225.773 125.159 225.773 126.712 226.774 126.712C227.776 126.712 227.776 125.159 226.774 125.159Z",
    fill: "#DBDBED"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M135.348 140.769C134.346 140.769 134.346 142.322 135.348 142.322C136.349 142.322 136.349 140.769 135.348 140.769Z",
    fill: "#DBDBED"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8339 170.62C93.8327 170.62 93.8327 172.173 94.8339 172.173C95.8351 172.173 95.8351 170.62 94.8339 170.62Z",
    fill: "#DBDBED"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2716 144.604C90.2705 144.604 90.2705 146.158 91.2716 146.158C92.2728 146.158 92.2728 144.604 91.2716 144.604Z",
    fill: "#DBDBED"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3432 121.322C85.342 121.322 85.342 122.875 86.3432 122.875C87.3444 122.875 87.3444 121.322 86.3432 121.322Z",
    fill: "#DBDBED"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8034 136.66C61.8022 136.66 61.8022 138.213 62.8034 138.213C63.8046 138.213 63.8046 136.66 62.8034 136.66Z",
    fill: "#DBDBED"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5126 96.667C32.5114 96.667 32.5114 98.2201 33.5126 98.2201C34.5138 98.2201 34.5138 96.667 33.5126 96.667Z",
    fill: "#DBDBED"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M156.427 144.325C155.425 144.325 155.425 145.878 156.427 145.878C157.428 145.878 157.428 144.325 156.427 144.325Z",
    fill: "#DBDBED"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M177.778 160.486C176.777 160.486 176.777 162.039 177.778 162.039C178.779 162.039 178.779 160.486 177.778 160.486Z",
    fill: "#DBDBED"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M202.684 144.876C201.682 144.876 201.682 146.429 202.684 146.429C203.685 146.429 203.685 144.876 202.684 144.876Z",
    fill: "#DBDBED"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9515 51.6641L67.6464 61.9381C56.8661 69.6961 47.7622 76.0718 33.0625 91.0907C39.6362 73.4081 46.2643 63.2117 56.9515 51.6641Z",
    fill: "#EDE3DB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M114.004 38.3925C99.7699 44.0305 86.6534 49.6606 74.4373 57.3642L62.0737 46.6165C73.1257 36.6608 88.0427 29.0193 102.673 26.3867C106.584 30.5026 110.092 34.2689 114.004 38.3925Z",
    fill: "#EDE3DB"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M221.752 282.789C159.391 290.733 98.2797 290.733 35.9185 282.789C38.3322 265.829 40.7459 248.861 43.1597 231.892C43.8426 227.07 44.5334 222.255 45.2164 217.433C47.9871 217.782 50.7579 218.116 53.5286 218.427C104.101 224.173 153.764 224.166 204.344 218.403C207.045 218.1 209.746 217.774 212.455 217.433C213.145 222.271 213.828 227.116 214.519 231.955C216.933 248.899 219.347 265.844 221.752 282.789Z",
    fill: "#510B00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5084_26628",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 217,
    width: 187,
    height: 72
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M221.752 282.789C159.391 290.733 98.2797 290.733 35.9185 282.789C38.3322 265.829 40.7459 248.861 43.1597 231.892C43.8426 227.07 44.5334 222.255 45.2164 217.433C47.9871 217.782 50.7579 218.116 53.5286 218.427C104.101 224.173 153.764 224.166 204.344 218.403C207.045 218.1 209.746 217.774 212.455 217.433C213.145 222.271 213.828 227.116 214.519 231.955C216.933 248.899 219.347 265.844 221.752 282.789Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5084_26628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7012 248.356C58.0456 243.223 51.1537 245.646 47.6845 249.637C45.263 252.425 43.7651 255.865 41.4522 258.723C39.3101 261.371 35.9573 263.771 32.3871 262.917C31.417 262.684 31.0212 264.182 31.9913 264.415C36.6403 265.526 40.7848 262.303 43.3692 258.746C46.2021 254.856 48.0958 249.831 52.7292 247.703C54.7394 246.779 57.1997 246.554 59.0934 247.882C60.9328 249.171 61.7865 251.548 61.7943 253.73C61.8021 256.494 60.6301 259.111 59.3495 261.495C58.3173 263.414 56.7185 265.984 54.165 265.642C51.534 265.285 51.5806 261.791 51.9376 259.834C52.1704 258.552 52.6206 256.836 54.103 256.525C54.6074 256.417 55.337 256.502 55.4767 257.108C55.5776 257.543 55.337 258.094 54.8636 258.079C53.8624 258.04 53.8624 259.593 54.8636 259.632C57.2385 259.725 57.743 256.277 55.8104 255.236C54.7471 254.669 53.3734 254.926 52.4343 255.609C51.2546 256.463 50.7268 257.9 50.463 259.282C50.0283 261.55 49.9585 264.532 51.8445 266.217C53.9943 268.135 57.1143 267.04 58.8218 265.107C59.8462 263.949 60.5758 262.559 61.2665 261.185C61.9961 259.725 62.6403 258.203 63.005 256.611C63.6492 253.823 63.4086 250.748 61.7089 248.364L61.7012 248.356Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2045 230.65C60.3197 227.885 58.1155 226.037 55.4146 225.144C52.3645 224.127 48.8564 224.197 45.6976 224.515C42.7794 224.81 39.6517 225.641 37.7579 228.048C36.1902 230.036 35.4839 233.019 36.912 235.278C38.4021 237.631 41.3514 238.136 43.9126 237.756C46.4427 237.383 50.3621 235.682 49.7645 232.475C49.4929 231.015 48.2588 229.974 46.8851 229.563C45.0535 229.011 43.1287 229.703 41.429 230.37C40.5054 230.728 40.8935 232.234 41.8248 231.877C43.0976 231.38 44.5179 230.766 45.915 230.945C47.0869 231.093 48.4917 231.993 48.2433 233.352C47.8552 235.496 44.5257 236.249 42.7639 236.335C40.6141 236.435 38.177 235.605 37.7502 233.22C37.3388 230.914 38.829 228.623 40.7615 227.497C42.9967 226.2 45.6821 225.998 48.2123 225.936C50.82 225.866 53.6063 225.921 56.02 227.047C58.1311 228.025 59.7842 229.959 59.986 232.343C60.2188 235.1 58.0302 236.319 55.9579 237.577L37.8899 248.542C37.0361 249.063 37.8045 250.414 38.6582 249.893L49.0039 243.611C50.7036 242.578 52.3955 241.553 54.0952 240.52C55.6863 239.557 57.3549 238.656 58.8761 237.577C61.1812 235.946 62.0893 233.376 61.22 230.658L61.2045 230.65Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2295 278.022C55.9656 275.513 54.7627 273.121 53.1406 271.219C49.5238 266.994 43.4856 265.589 38.3167 267.538C35.3209 268.672 32.7674 270.613 30.2528 272.547C29.4612 273.152 30.571 274.247 31.3471 273.642C33.6289 271.887 35.9961 270.077 38.7047 269.037C41.5298 267.957 44.6343 267.911 47.4594 269.021C50.005 270.023 52.1161 271.941 53.42 274.341C54.0797 275.56 54.5997 276.958 54.6928 278.348C54.7937 279.862 54.0719 281.695 52.2713 281.508C51.2779 281.407 51.2856 282.961 52.2713 283.062C55.0731 283.357 56.4623 280.406 56.214 278.014L56.2295 278.022Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0211 224.569C79.8546 222.628 75.5937 224.111 73.2808 226.705C71.9304 228.219 71.0301 230.059 70.3704 231.97C69.6408 234.059 68.9423 236.365 68.7095 238.571C68.4922 240.613 69.1829 243.083 71.3638 243.781C73.4981 244.465 75.6247 242.958 76.9131 241.382C79.8779 237.74 80.9489 232.816 80.002 228.25C79.8002 227.272 78.3023 227.668 78.5041 228.646C79.2647 232.304 78.5429 236.171 76.5095 239.308C75.6247 240.675 74.057 242.601 72.2098 242.376C69.8426 242.096 70.1298 238.975 70.5023 237.351C71.2784 233.927 72.1632 229.958 74.771 227.411C77.0683 225.159 81.2826 224.142 83.5023 227.062C85.9704 230.308 84.4104 234.866 83.1919 238.291C81.9501 241.755 80.1262 245.273 77.0838 247.486C74.282 249.528 70.448 250.499 67.2814 248.682C65.8534 247.858 64.6426 246.554 64.0993 244.985C63.5017 243.246 63.9286 241.498 64.697 239.883C65.5507 238.089 66.6528 236.42 67.2737 234.517C67.817 232.855 68.0187 231.053 67.9101 229.314C67.6773 225.703 66.1793 222.255 63.5871 219.715C62.8731 219.017 61.771 220.112 62.4928 220.81C65.3334 223.591 66.7226 227.621 66.319 231.566C66.094 233.764 65.1859 235.643 64.1537 237.553C63.2068 239.308 62.2677 241.157 62.2522 243.191C62.2211 246.896 65.2946 250.056 68.7405 250.934C72.691 251.936 76.8665 250.079 79.6528 247.315C82.7495 244.232 84.4492 239.937 85.6134 235.806C86.6844 232.009 86.894 226.938 83.0367 224.577L83.0211 224.569Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3167 252.836C75.1435 251.958 72.9006 253.294 71.2552 254.638C67.5453 257.674 64.3633 261.65 62.3376 265.999C59.8618 271.295 59.2176 277.189 60.6068 282.882C60.8474 283.852 62.3453 283.456 62.1047 282.486C59.7764 272.965 63.8277 263.731 70.7197 257.185C72.14 255.834 74.445 253.465 76.6337 254.226C78.3489 254.832 78.4653 257.107 77.8988 258.567C77.0994 260.617 75.0349 261.961 73.4904 263.413C72.008 264.811 70.743 266.465 69.7883 268.267C67.6462 272.297 66.9477 276.987 67.8636 281.461C68.0653 282.439 69.5632 282.043 69.3615 281.064C68.4068 276.405 69.4158 271.474 72.0391 267.513C73.3818 265.486 75.2056 264.05 76.9364 262.388C78.4343 260.951 79.6683 259.243 79.7459 257.107C79.808 255.337 79.0164 253.519 77.3012 252.828L77.3167 252.836Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.256 276.647C102.61 268.594 94.9113 262.995 86.7698 263.95C82.245 264.486 78.1394 266.846 75.5394 270.605C73.0092 274.255 72.0779 278.899 72.9859 283.24C73.1877 284.218 74.6934 283.822 74.4838 282.844C73.0558 276.002 76.882 268.71 83.4946 266.303C90.2003 263.864 97.6122 266.536 101.136 272.748C102.75 275.591 103.456 279.015 102.735 282.23C101.989 285.585 99.762 288.451 96.2617 289.134C92.6605 289.841 88.8343 288.288 85.8462 286.393C83.0444 284.614 80.0486 281.663 81.042 278.021C82.1364 274.014 86.5758 272.414 90.2235 273.944C94.1662 275.591 95.928 280.025 95.3692 284.086C95.2373 285.065 96.7352 285.469 96.8671 284.482C97.4259 280.413 96.1531 276.088 92.7382 273.603C89.5638 271.296 85.0856 271.102 82.0355 273.711C78.962 276.328 78.4808 280.7 80.8247 283.947C83.1997 287.231 87.3829 289.522 91.2635 290.446C95.1208 291.371 99.3274 290.679 101.935 287.472C104.372 284.475 105.001 280.359 104.24 276.647H104.256Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.141 225.672C111.644 224.803 110.294 225.571 110.791 226.441C113.515 231.186 114.299 236.909 112.948 242.213C111.706 247.098 108.586 251.377 104.411 254.18C100.569 256.759 95.5088 258.467 90.8909 257.217C88.7177 256.627 86.7619 255.244 86.0324 253.039C85.1554 250.406 86.0479 247.502 87.3362 245.164C90.1458 240.054 95.7804 234.774 93.39 228.359C93.0407 227.427 91.5428 227.816 91.8921 228.755C94.2903 235.201 87.6777 240.404 85.3339 245.723C84.2395 248.201 83.6807 251.113 84.6431 253.722C85.4736 255.982 87.3207 257.566 89.5327 258.405C94.2127 260.175 99.6455 258.77 103.837 256.378C108.47 253.73 112.126 249.467 113.911 244.427C116.076 238.299 115.377 231.302 112.149 225.68L112.141 225.672Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.942 266.373C143.729 264.284 139.297 263.989 136.108 266.272C132.786 268.648 131.272 273.021 131.521 276.997C131.653 279.093 132.359 281.408 133.958 282.86C135.502 284.258 137.714 284.553 139.515 283.458C141.455 282.277 142.518 279.994 142.177 277.758C141.804 275.335 140.05 273.347 137.939 272.221C137.062 271.755 136.286 273.098 137.171 273.572C138.971 274.535 140.547 276.251 140.687 278.379C140.811 280.274 139.406 282.363 137.427 282.58C135.564 282.782 134.245 281.167 133.64 279.606C132.972 277.882 132.918 275.956 133.22 274.147C133.826 270.52 136.115 266.955 139.973 266.319C143.512 265.736 147.33 267.631 148.991 270.807C150.792 274.24 150.124 278.658 147.843 281.695C145.382 284.972 141.121 286.51 137.117 286.339C132.972 286.16 129.107 284.063 126.235 281.151C123.666 278.542 122.231 274.946 119.444 272.539C118.008 271.304 116.216 270.52 114.291 270.73C112.382 270.939 110.705 272.073 109.533 273.549C106.266 277.672 107.57 283.062 108.889 287.674C109.169 288.637 110.666 288.241 110.387 287.278C109.083 282.728 107.469 276.29 112.234 273.106C116.464 270.279 119.755 274.908 121.835 278.022C124.287 281.679 127.291 284.832 131.412 286.572C135.494 288.296 140.136 288.358 144.187 286.486C148.106 284.677 150.877 281.035 151.444 276.74C151.971 272.687 150.404 268.625 146.934 266.365L146.942 266.373Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.592 282.036C119.025 280.716 118.032 279.691 116.689 279.163C115.502 278.697 114.097 278.744 113.057 279.536C111.947 280.382 111.52 281.842 111.676 283.193C111.885 285.003 113.026 286.447 114.144 287.814C114.408 288.14 114.966 288.086 115.238 287.814C115.556 287.496 115.502 287.045 115.238 286.719C114.47 285.779 113.647 284.785 113.321 283.597C113.08 282.712 113.158 281.617 113.779 280.965C114.376 280.343 115.269 280.297 116.115 280.6C117.062 280.941 117.714 281.671 118.141 282.595C118.723 283.83 118.831 285.259 118.948 286.602C118.987 287.022 119.282 287.379 119.724 287.379C120.12 287.379 120.539 287.022 120.5 286.602C120.368 285.049 120.213 283.488 119.592 282.044V282.036Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.146 267.856C154.835 266.908 153.33 267.296 153.648 268.252C155.643 274.363 154.393 281.329 150.287 286.299C149.659 287.06 150.745 288.171 151.382 287.394C155.829 282.005 157.327 274.519 155.146 267.856Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.96 270.644C180.292 266.637 178.476 262.591 175.581 259.694C172.849 256.961 168.813 255.408 165.212 257.434C161.138 259.725 159.834 264.563 159.787 268.928C159.733 274.139 161.169 279.839 158.476 284.646C157.987 285.515 159.337 286.284 159.826 285.414C161.65 282.168 161.79 278.402 161.596 274.768C161.394 270.885 160.765 266.606 162.411 262.933C163.753 259.935 166.664 257.372 170.148 258.188C173.579 258.995 176.039 262.164 177.553 265.154C179.19 268.392 179.912 272.057 179.679 275.676C179.47 279.015 178.484 283.357 175.209 284.987C171.817 286.68 169.124 283.659 167.836 280.825C166.245 277.33 165.476 273.059 165.693 269.231C165.771 267.864 166.245 265.534 168.022 265.542C169.923 265.55 170.994 268.159 171.569 269.603C173.191 273.727 173.672 278.262 172.981 282.634C172.826 283.613 174.324 284.017 174.479 283.03C175.201 278.503 174.813 273.828 173.191 269.526C172.539 267.794 171.755 265.969 170.242 264.82C168.961 263.841 167.23 263.678 165.934 264.742C164.638 265.806 164.234 267.639 164.141 269.231C164.017 271.475 164.289 273.789 164.731 275.987C165.468 279.629 166.819 284.102 170.195 286.175C173.734 288.342 177.731 286.051 179.462 282.704C181.332 279.093 181.604 274.605 180.952 270.644H180.96Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.89 235.146C186.781 233.05 185.368 231.1 183.723 229.4C182.139 227.761 180.246 226.216 177.987 225.641C175.961 225.129 173.718 225.439 172.112 226.837C170.661 228.103 170.117 230.052 170.109 231.924C170.094 234.152 170.746 236.311 171.444 238.4C172.306 241.002 173.299 243.557 174.409 246.065C175.341 248.162 176.474 251.276 179.035 251.827C181.262 252.309 182.45 250.165 182.496 248.263C182.558 245.638 181.666 242.811 180.75 240.388C179.741 237.725 178.375 235.232 176.675 232.941C176.086 232.149 174.727 232.91 175.325 233.71C177.979 237.274 179.819 241.367 180.649 245.739C180.859 246.834 181.612 250.592 179.431 250.328C178.476 250.212 177.692 249.125 177.242 248.379C176.652 247.416 176.218 246.337 175.76 245.304C174.782 243.083 173.897 240.823 173.121 238.532C172.484 236.661 171.832 234.743 171.693 232.754C171.569 230.992 171.84 229.027 173.315 227.862C175.03 226.511 177.467 226.853 179.268 227.823C182.877 229.772 185.585 233.686 187.246 237.336C188.899 240.986 189.807 245.312 189.233 249.311C188.713 252.945 186.563 256.533 182.504 256.588C178.6 256.642 175.24 253.947 173.268 250.779C168.899 243.759 168.068 232.056 158.468 229.788C157.498 229.563 157.102 231.062 158.072 231.287C162.604 232.358 165.383 236.544 167.137 240.567C169.101 245.063 170.304 250.08 173.61 253.854C176.194 256.805 180.533 258.917 184.483 257.861C188.62 256.758 190.483 252.588 190.847 248.651C191.274 244.038 190.048 239.208 187.89 235.146Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.155 235.279C194.146 230.371 193.579 224.942 196.335 220.485C196.862 219.638 195.512 218.87 194.984 219.716C189.947 227.854 194.821 237.391 195.683 245.933C196.148 250.499 195.434 254.91 192.252 258.389C189.668 261.216 186.307 263.352 184.305 266.683C181.495 271.35 182.908 276.856 184.382 281.718C184.67 282.673 186.175 282.285 185.88 281.322C184.545 276.918 183.079 271.84 185.578 267.561C187.533 264.221 190.995 262.125 193.525 259.282C199.688 252.348 196.8 243.332 195.139 235.279H195.155Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.766 228.771C218.539 222.628 214.558 216.283 207.899 215.274C206.921 215.126 206.517 216.625 207.503 216.773C212.835 217.588 216.374 222.247 217.779 227.171C218.602 230.037 218.85 233.019 218.927 235.993C219.005 238.835 218.974 241.732 218.345 244.52C217.763 247.082 216.661 249.552 214.69 251.33C212.936 252.907 210.538 253.971 208.147 253.761C202.986 253.31 201.527 247.455 200.976 243.223C200.037 236.086 199.462 228.879 198.717 221.712C198.616 220.725 197.064 220.718 197.165 221.712C197.91 228.856 198.516 236.024 199.408 243.145C199.998 247.851 201.504 253.769 206.797 255.097C212.199 256.456 217.197 252.247 219.067 247.494C220.193 244.628 220.48 241.507 220.511 238.455C220.542 235.224 220.402 231.947 219.766 228.771Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.338 240.21C212.105 238.199 211.803 236.187 211.446 234.192C210.631 229.563 209.521 224.997 208.147 220.508C207.852 219.553 206.354 219.949 206.649 220.904C207.681 224.267 208.566 227.684 209.288 231.132C209.994 234.533 210.732 238.059 210.91 241.538C210.988 243.021 210.848 244.73 209.591 245.724C208.364 246.694 206.874 246.399 206.284 244.924C205.687 243.433 205.687 241.647 205.493 240.078C205.275 238.3 205.05 236.513 204.833 234.735L203.296 222.333C203.172 221.355 201.62 221.339 201.744 222.333C202.272 226.597 202.8 230.852 203.327 235.116C203.599 237.275 203.863 239.441 204.135 241.6C204.329 243.138 204.375 244.869 205.213 246.228C206.905 248.977 210.669 247.875 211.872 245.273C212.61 243.689 212.54 241.911 212.346 240.218L212.338 240.21Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 260.097C204.864 258.738 203.374 257.923 201.705 258.016C199.726 258.125 197.996 259.328 196.544 260.571C193.742 262.955 191.6 266.069 190.234 269.478C188.659 273.408 188.185 277.687 188.868 281.857C189.031 282.843 190.529 282.439 190.366 281.461C189.256 274.72 191.616 267.552 196.459 262.745C197.716 261.495 199.214 260.152 200.968 259.701C202.792 259.227 204.344 260.183 204.996 261.899C206.401 265.58 203.048 268.927 200.945 271.521C198.609 274.409 196.389 278.533 198.772 282.082C199.323 282.905 200.681 282.144 200.122 281.313C197.39 277.236 201.822 273.05 204.135 270.068C206.3 267.273 208.07 263.382 205.796 260.097H205.803Z",
    fill: "#682117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.205 261.581C223.84 259.313 222.762 256.813 220.542 255.826C218.136 254.755 215.396 255.951 213.782 257.853C211.632 260.393 210.646 263.957 209.459 267.009C208.046 270.643 206.68 274.293 205.353 277.966C205.012 278.906 206.517 279.294 206.851 278.362C208.729 273.136 210.677 267.933 212.781 262.792C213.65 260.664 214.744 258.296 216.98 257.333C219.308 256.331 221.264 257.721 222.133 259.888C223.716 263.833 222.723 268.811 220.744 272.422C219.711 274.317 218.314 276.079 216.607 277.407C215.808 278.029 214.341 278.937 213.44 278.013C212.711 277.26 212.928 275.831 213.099 274.914C214.007 269.991 216.941 265.549 221.109 262.769C221.939 262.218 221.171 260.866 220.34 261.418C215.924 264.369 212.703 269.005 211.655 274.231C211.244 276.273 211.166 279.318 213.759 279.885C216.297 280.436 218.757 277.788 220.185 276.033C223.421 272.041 225.012 266.706 224.197 261.604L224.205 261.581Z",
    fill: "#682117"
  }))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8323 132.658H94.6459L101.039 104.547L94.6459 94.1904L69.8323 132.658Z",
    fill: "#252B3A"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M156.677 127.302H119.459V132.658H156.677V127.302Z",
    fill: "#313949"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M119.459 127.302V132.658L100.744 105.85L99.2544 103.722L98.758 103.017L94.6459 97.1239L90.5337 103.017L90.0373 103.722L69.8323 132.658V127.302L86.3009 103.722L86.7906 103.017L94.6459 91.7676L102.494 103.017L102.991 103.722L119.459 127.302Z",
    fill: "#3B4354"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M177.948 127.302H119.46L102.991 103.722L102.495 103.017L94.646 91.7676H153.135L160.983 103.017L161.48 103.722L177.948 127.302Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2239 144.612H76.0375L82.4304 116.501L76.0375 106.145L51.2239 144.612Z",
    fill: "#252B3A"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M185.589 185.765H104.601V109.159L168.725 111.347L185.589 131.115V185.765Z",
    fill: "#624124"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M185.589 185.765H131.816V109.159L168.282 111.347L185.589 131.115V185.765Z",
    fill: "#B09161"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M194.256 185.765H133.191V109.159L168.724 110.374L194.256 130.625V185.765Z",
    fill: "#624124"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M200.448 185.764H141.422L141.416 139.256H190.446L200.555 154.734L200.448 185.764Z",
    fill: "#624124"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M131.816 139.256L142.046 139.974V185.764H131.816",
    fill: "#75522F"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M203.413 152.385H143.918V156.452H203.413V152.385Z",
    fill: "#313949"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M143.918 152.385L131.816 139.249H194.256C198.207 144.303 204.64 151.257 203.413 152.364C200.79 156.15 191.13 151.881 184.636 152.318C180.947 152.566 177.177 154.15 173.669 154.116C169.134 154.076 165.015 152.452 161.232 152.499C152.363 152.613 147.178 153.881 143.918 152.378V152.385Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M143.918 152.371V156.452L131.837 139.256H134.761L143.918 152.371Z",
    fill: "#3B4354"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1673 107.943L65.7336 135.772V185.764H85.1673H104.601V135.772L85.1673 107.943Z",
    fill: "#75522F"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1918 141.531H77.5737V130.839C77.5737 127.348 80.3979 124.522 83.8861 124.522C87.3744 124.522 90.1986 127.348 90.1986 130.839V141.531H90.1918Z",
    fill: "#4C2E17"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4069 130.792V140.753H78.3518V130.906C78.3518 127.852 80.8204 125.382 83.8727 125.382C84.5435 125.382 85.1673 125.496 85.7577 125.704C86.5291 125.979 87.2267 126.429 87.7902 126.999C88.0317 127.241 88.2531 127.496 88.4342 127.771C88.8032 128.302 89.0715 128.906 89.2325 129.537C89.3331 129.939 89.3935 130.356 89.4069 130.785V130.792Z",
    fill: "#FEC442"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4408 127.778L78.3584 137.866V133.114L85.7575 125.704C86.5357 125.986 87.2266 126.429 87.7901 127C88.0316 127.241 88.2463 127.503 88.4408 127.778Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4069 131.161V132.45L81.0955 140.753H79.6868L89.4069 131.161Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2012 141.115V125.174H83.6041V141.115H84.2012Z",
    fill: "#4C2E17"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M199.602 127.288H165.538V132.644H199.602V127.288Z",
    fill: "#313949"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M200.253 127.301C200.837 129.04 199.924 129.221 199.602 129.322C196.288 130.288 193.397 127.892 190.868 128.677C187.3 129.785 184.227 130.476 181.484 128.557C180.585 127.926 179.552 127.966 178.518 128.335C177.257 128.792 175.688 129.235 174.373 129.235C172.092 129.235 169.65 127.295 169.65 127.295H165.538V128.335L143.824 103.729H183.154C186.501 107.353 190.654 114.314 193.404 117.73C197.067 122.274 199.227 124.241 200.253 127.301Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M169.348 132.644H165.538V128.328L169.348 132.644Z",
    fill: "#313949"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M153.638 110.226L119.721 118.717L113.254 103.722H162.264L153.638 110.226Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M138.068 139.256H100.851V144.612H138.068V139.256Z",
    fill: "#313949"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0375 103.722L51.2239 139.256V144.612L76.0375 109.078L100.851 144.612V139.256L76.0375 103.722Z",
    fill: "#3B4354"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0374 103.722H113.254L138.068 139.256C137.753 141.236 135.794 140.209 134.613 140.222C132.574 140.242 131.729 141.82 129.904 141.934C127.992 142.055 121.874 140.571 120.177 140.752C109.692 141.873 106.171 142.793 100.851 139.256L76.0374 103.722Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M151.391 105.548L142.08 118.965L139.899 122.107L128.603 132.645L119.721 118.717L130.796 105.548H151.391Z",
    fill: "#E7F0FB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M148.264 115.166L162.975 132.658H165.297L171.079 132.645L151.357 109.192",
    fill: "#252B3A"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M151.391 111.287L169.362 132.658H174.178V132.645L151.391 105.548L128.603 132.645V132.658H133.413L151.391 111.287Z",
    fill: "#313949"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M169.429 108.159V95.5068H172.723V113.542L169.429 108.159Z",
    fill: "#C4A470"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M169.429 108.159V95.5068H172.723V113.542L169.429 108.159Z",
    fill: "#75522F"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M177.432 95.5068H172.528V113.549H177.432V95.5068Z",
    fill: "#624124"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M170.361 93.5529C168.919 93.7811 168.785 94.8953 168.939 95.6001C169.093 96.3116 169.409 97.6003 169.288 98.0634C169.174 98.5266 169.509 99.0501 170.033 99.0501C170.556 99.0501 170.925 98.5601 170.891 98.191C170.858 97.8218 170.616 96.4055 171.079 96.4055C171.542 96.4055 171.448 97.4862 171.475 97.8218C171.508 98.1574 172.461 99.0568 173.199 98.3789C173.937 97.701 173.32 96.5599 173.722 96.4055C174.125 96.2512 174.816 96.1303 174.977 97.1774C175.138 98.2245 177.418 98.2849 177.633 97.1774C177.848 96.0699 178.451 95.0228 177.425 94.4389C176.399 93.8549 174.266 94.4724 173.427 94.3785C172.588 94.2845 171.804 93.3314 170.361 93.5596V93.5529Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M200.448 182.307H65.7336V185.757H200.448V182.307Z",
    fill: "#C4A470"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M179.86 185.764H164.545L164.311 159.398H179.625L179.86 185.764Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M178.74 160.433H165.337V185.764H178.74V160.433Z",
    fill: "#4C2E17"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M177.546 161.419H166.484V171.44H177.546V161.419Z",
    fill: "#4C2E17"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M177.009 161.902H167.014V170.957H177.009V161.902Z",
    fill: "#FEC442"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M172.119 161.902V164.601L167.705 170.957H167.014V167.487L170.898 161.902H172.119Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M177.016 161.902V165.769L173.414 170.957H172.038V168.474L176.607 161.902H177.016Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M172.367 161.419H171.669V171.44H172.367V161.419Z",
    fill: "#4C2E17"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M160.373 159.398H153.255V179.011H160.373V159.398Z",
    fill: "#4C2E17"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M159.635 160.277H154V178.145H159.635V160.277Z",
    fill: "#FEC442"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M159.628 160.365V164.822L154 172.937V168.473L159.628 160.365Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M159.628 168.889V171.03L154.698 178.138H154V176.99L159.628 168.889Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M153.369 159.398H146.252V179.011H153.369V159.398Z",
    fill: "#4C2E17"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M152.631 160.277H146.997V178.145H152.631V160.277Z",
    fill: "#FEC442"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M152.625 160.365V164.822L146.997 172.937V168.473L152.625 160.365Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M152.625 168.889V171.03L147.694 178.138H146.997V176.99L152.625 168.889Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M196.939 159.398H189.822V179.011H196.939V159.398Z",
    fill: "#4C2E17"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M196.195 160.277H190.56V178.145H196.195V160.277Z",
    fill: "#FEC442"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M196.195 160.365V164.822L190.56 172.937V168.473L196.195 160.365Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M196.195 168.889V171.03L191.264 178.138H190.56V176.99L196.195 168.889Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M189.936 159.398H182.818V179.011H189.936V160.002V159.392V159.398Z",
    fill: "#4C2E17"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M189.191 160.277H183.556V178.145H189.191V160.277Z",
    fill: "#FEC442"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M189.191 160.365V164.822L183.556 172.937V168.473L189.191 160.365Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M189.191 168.89V171.031L184.261 178.139H183.556V176.991L189.191 168.89Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M152.551 128.732C152.551 131.094 150.633 133.014 148.272 133.014C147.527 133.014 146.823 132.819 146.205 132.477C145.434 132.054 144.81 131.396 144.421 130.604C144.146 130.04 143.992 129.403 143.992 128.732C143.992 126.369 145.904 124.449 148.272 124.449C148.942 124.449 149.58 124.604 150.143 124.879C150.935 125.268 151.592 125.892 152.015 126.664C152.364 127.275 152.551 127.987 152.551 128.738V128.732Z",
    fill: "#FEC442"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M152.008 126.658L146.198 132.477C145.427 132.054 144.803 131.396 144.414 130.604L150.136 124.879C150.928 125.268 151.585 125.892 152.008 126.664V126.658Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M148.265 124.449C150.626 124.449 152.545 126.368 152.545 128.731C152.545 131.094 150.626 133.013 148.265 133.013C145.903 133.013 143.985 131.094 143.985 128.731C143.985 126.368 145.903 124.449 148.265 124.449ZM148.265 123.791C145.541 123.791 143.321 126.006 143.321 128.738C143.321 131.47 145.535 133.685 148.265 133.685C150.995 133.685 153.209 131.47 153.209 128.738C153.209 126.006 150.995 123.791 148.265 123.791Z",
    fill: "#4C2E17"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M148.634 123.919H147.909V133.544H148.634V123.919Z",
    fill: "#4C2E17"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4755 153.379H69.4099V171.481H72.4755V153.379Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6906 153.379H96.625V171.481H99.6906V153.379Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1828 153.38H73.7434V171.482H95.1828V153.38Z",
    fill: "#4C2E17"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3912 154.515H74.5483V170.63H94.3912V154.515Z",
    fill: "#FEC442"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8626 154.515L74.763 170.63H74.5483V166.1L86.1267 154.515H90.8626Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3911 159.165V163.911L87.6761 170.629H82.9268L94.3911 159.165Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9526 153.997H84.2214V170.838H84.9526V153.997Z",
    fill: "#4C2E17"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1826 167.656V166.925H73.9914V167.656H95.1826Z",
    fill: "#4C2E17"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5084_26628)"
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M176.133 177.696C176.189 177.411 176.573 177.152 176.573 176.852C176.573 176.551 176.189 176.292 176.133 176.007C176.075 175.714 176.33 175.328 176.22 175.058C176.107 174.783 175.653 174.692 175.49 174.448C175.327 174.202 175.416 173.746 175.208 173.538C175.001 173.329 174.547 173.419 174.304 173.254C174.062 173.091 173.97 172.635 173.698 172.521C173.43 172.409 173.046 172.665 172.754 172.608C172.472 172.551 172.214 172.165 171.915 172.165C171.616 172.165 171.358 172.551 171.076 172.608C170.784 172.666 170.4 172.409 170.132 172.521C169.859 172.634 169.768 173.091 169.526 173.254C169.282 173.418 168.828 173.329 168.621 173.537C168.414 173.746 168.503 174.202 168.339 174.447C168.177 174.691 167.724 174.783 167.61 175.057C167.499 175.327 167.755 175.714 167.697 176.007C167.641 176.292 167.257 176.551 167.257 176.851C167.257 177.152 167.641 177.411 167.697 177.696C167.755 177.989 167.499 178.375 167.61 178.645C167.723 178.92 168.177 179.011 168.339 179.255C168.503 179.501 168.414 179.957 168.621 180.166C168.829 180.374 169.282 180.285 169.526 180.449C169.768 180.612 169.859 181.069 170.132 181.183C170.4 181.295 170.784 181.038 171.076 181.096C171.359 181.152 171.617 181.538 171.915 181.538C172.214 181.538 172.472 181.152 172.755 181.096C173.046 181.038 173.431 181.294 173.699 181.183C173.972 181.069 174.063 180.613 174.305 180.449C174.549 180.285 175.003 180.374 175.21 180.166C175.416 179.957 175.328 179.501 175.492 179.255C175.654 179.012 176.107 178.92 176.221 178.646C176.332 178.376 176.077 177.989 176.134 177.696H176.133ZM171.914 179.118C170.67 179.118 169.661 178.103 169.661 176.852C169.661 175.6 170.67 174.585 171.914 174.585C173.158 174.585 174.167 175.6 174.167 176.852C174.167 178.103 173.159 179.118 171.914 179.118Z",
    fill: "#6A7520"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.837 174.418C171.837 174.418 171.345 173.533 170.331 173.533V175.484C171.345 175.484 171.837 174.6 171.837 174.6L171.919 174.509L171.837 174.418Z",
    fill: "#292D1C"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.837 174.418C171.837 174.418 171.345 173.533 170.331 173.533V175.484C171.345 175.484 171.837 174.6 171.837 174.6L171.919 174.509L171.837 174.418Z",
    fill: "#C11B2A"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.992 174.418L171.91 174.509L171.992 174.6C171.992 174.6 172.484 175.484 173.498 175.484V173.533C172.484 173.533 171.992 174.418 171.992 174.418Z",
    fill: "#292D1C"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.992 174.418L171.91 174.509L171.992 174.6C171.992 174.6 172.484 175.484 173.498 175.484V173.533C172.484 173.533 171.992 174.418 171.992 174.418Z",
    fill: "#C11B2A"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.252 174.509C172.252 174.696 172.101 174.849 171.914 174.849C171.728 174.849 171.576 174.697 171.576 174.509C171.576 174.32 171.727 174.169 171.914 174.169C172.101 174.169 172.252 174.321 172.252 174.509Z",
    fill: "#292D1C"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.252 174.509C172.252 174.696 172.101 174.849 171.914 174.849C171.728 174.849 171.576 174.697 171.576 174.509C171.576 174.32 171.727 174.169 171.914 174.169C172.101 174.169 172.252 174.321 172.252 174.509Z",
    fill: "#5AC7D8"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M172.688 180.371C172.688 180.775 172.363 181.103 171.961 181.103C171.559 181.103 171.233 180.775 171.233 180.371C171.233 179.966 171.559 179.639 171.961 179.639C172.363 179.639 172.688 179.966 172.688 180.371Z",
    fill: "#5AC7D8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M172.506 179.887C172.537 179.969 172.555 180.057 172.555 180.15C172.555 180.554 172.23 180.882 171.828 180.882C171.61 180.882 171.415 180.785 171.282 180.633C171.387 180.907 171.651 181.102 171.961 181.102C172.363 181.102 172.688 180.774 172.688 180.37C172.688 180.185 172.619 180.016 172.506 179.887V179.887Z",
    fill: "#5AC7D8"
  }))), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M172.064 179.509H171.857C171.797 179.509 171.748 179.558 171.748 179.619V179.724C171.748 179.785 171.797 179.834 171.857 179.834H172.064C172.125 179.834 172.173 179.785 172.173 179.724V179.619C172.173 179.558 172.125 179.509 172.064 179.509Z",
    fill: "#5AC7D8"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M175.415 175.504C175.418 175.267 175.229 175.072 174.993 175.069C174.757 175.066 174.564 175.256 174.561 175.493C174.558 175.731 174.747 175.925 174.982 175.928C175.218 175.931 175.412 175.741 175.415 175.504Z",
    fill: "#5AC7D8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M175.309 175.216C175.327 175.264 175.338 175.316 175.338 175.37C175.338 175.608 175.146 175.8 174.911 175.8C174.783 175.8 174.669 175.743 174.591 175.654C174.652 175.814 174.807 175.929 174.989 175.929C175.224 175.929 175.416 175.737 175.416 175.499C175.416 175.391 175.375 175.292 175.309 175.216Z",
    fill: "#5AC7D8"
  }))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M175.05 174.993H174.928C174.892 174.993 174.864 175.022 174.864 175.057V175.12C174.864 175.155 174.892 175.184 174.928 175.184H175.05C175.085 175.184 175.114 175.155 175.114 175.12V175.057C175.114 175.022 175.085 174.993 175.05 174.993Z",
    fill: "#5AC7D8"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M169.609 174.8C169.609 175.037 169.418 175.229 169.182 175.229C168.946 175.229 168.755 175.037 168.755 174.8C168.755 174.563 168.946 174.37 169.182 174.37C169.418 174.37 169.609 174.563 169.609 174.8Z",
    fill: "#FFDBBC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M169.503 174.517C169.521 174.564 169.532 174.616 169.532 174.671C169.532 174.908 169.34 175.1 169.105 175.1C168.977 175.1 168.862 175.044 168.784 174.954C168.846 175.115 169.001 175.23 169.183 175.23C169.418 175.23 169.61 175.037 169.61 174.8C169.61 174.692 169.569 174.592 169.503 174.517Z",
    fill: "#FFDBBC"
  }))), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M169.243 174.294H169.121C169.086 174.294 169.057 174.323 169.057 174.358V174.421C169.057 174.456 169.086 174.485 169.121 174.485H169.243C169.278 174.485 169.307 174.456 169.307 174.421V174.358C169.307 174.323 169.278 174.294 169.243 174.294Z",
    fill: "#FFDBBC"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M172.342 173.017C172.342 173.255 172.15 173.447 171.915 173.447C171.679 173.447 171.488 173.255 171.488 173.017C171.488 172.78 171.679 172.588 171.915 172.588C172.15 172.588 172.342 172.78 172.342 173.017Z",
    fill: "#FFB469"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M172.235 172.734C172.253 172.782 172.264 172.834 172.264 172.889C172.264 173.126 172.072 173.318 171.837 173.318C171.709 173.318 171.595 173.262 171.517 173.172C171.578 173.333 171.733 173.448 171.915 173.448C172.15 173.448 172.342 173.255 172.342 173.018C172.342 172.909 172.301 172.81 172.235 172.734Z",
    fill: "#FFB469"
  }))), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M171.854 172.512H171.975C172.011 172.512 172.039 172.541 172.039 172.576V172.638C172.039 172.674 172.01 172.702 171.975 172.702H171.854C171.818 172.702 171.79 172.673 171.79 172.638V172.576C171.79 172.54 171.819 172.512 171.854 172.512Z",
    fill: "#FFB469"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M175.694 177.847C175.694 178.252 175.369 178.579 174.967 178.579C174.565 178.579 174.239 178.252 174.239 177.847C174.239 177.443 174.565 177.115 174.967 177.115C175.369 177.115 175.694 177.443 175.694 177.847Z",
    fill: "#FFDBBC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M175.513 177.364C175.544 177.446 175.562 177.534 175.562 177.627C175.562 178.031 175.236 178.359 174.834 178.359C174.617 178.359 174.422 178.262 174.289 178.109C174.394 178.384 174.657 178.579 174.967 178.579C175.369 178.579 175.695 178.251 175.695 177.847C175.695 177.661 175.626 177.492 175.513 177.363V177.364Z",
    fill: "#FFDBBC"
  }))), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M175.07 176.985H174.863C174.803 176.985 174.754 177.034 174.754 177.095V177.201C174.754 177.262 174.803 177.311 174.863 177.311H175.07C175.131 177.311 175.18 177.262 175.18 177.201V177.095C175.18 177.034 175.131 176.985 175.07 176.985Z",
    fill: "#FFDBBC"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M169.603 178.222C169.603 178.627 169.277 178.954 168.875 178.954C168.473 178.954 168.147 178.627 168.147 178.222C168.147 177.818 168.473 177.49 168.875 177.49C169.277 177.49 169.603 177.818 169.603 178.222Z",
    fill: "#FFB469"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M169.42 177.739C169.451 177.821 169.469 177.909 169.469 178.002C169.469 178.406 169.144 178.734 168.742 178.734C168.524 178.734 168.33 178.637 168.197 178.484C168.302 178.759 168.565 178.954 168.875 178.954C169.277 178.954 169.603 178.626 169.603 178.222C169.603 178.036 169.533 177.867 169.42 177.738V177.739Z",
    fill: "#FFB469"
  }))), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M168.771 177.359H168.979C169.039 177.359 169.088 177.409 169.088 177.469V177.575C169.088 177.635 169.039 177.685 168.979 177.685H168.771C168.711 177.685 168.662 177.635 168.662 177.575V177.469C168.662 177.409 168.711 177.359 168.771 177.359Z",
    fill: "#FFB469"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5084_26628)"
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M154.434 153.94C155.793 152.679 155.843 150.586 154.545 149.265C153.248 147.944 151.095 147.895 149.736 149.156C148.377 150.417 148.327 152.51 149.624 153.831C150.922 155.152 153.075 155.201 154.434 153.94Z",
    fill: "url(#paint0_radial_5084_26628)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M154.525 151.557C154.519 152.867 153.421 153.925 152.072 153.919C150.724 153.914 149.636 152.846 149.642 151.534C149.648 150.224 150.746 149.166 152.095 149.172C153.443 149.178 154.531 150.245 154.525 151.557Z",
    fill: "url(#paint1_radial_5084_26628)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M158.317 159.802C158.307 161.629 156.777 163.103 154.9 163.093C153.02 163.083 151.504 161.596 151.514 159.771C151.524 157.943 153.053 156.47 154.931 156.48C156.811 156.489 158.327 157.976 158.317 159.802Z",
    fill: "url(#paint2_radial_5084_26628)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M157.357 159.797C157.351 161.107 156.253 162.165 154.903 162.16C153.556 162.154 152.467 161.086 152.473 159.774C152.479 158.464 153.578 157.406 154.927 157.412C156.275 157.418 157.363 158.486 157.357 159.797Z",
    fill: "url(#paint3_radial_5084_26628)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M164.867 156.266C164.857 158.094 163.328 159.567 161.45 159.558C159.57 159.548 158.054 158.061 158.064 156.236C158.074 154.408 159.603 152.935 161.481 152.944C163.361 152.954 164.877 154.441 164.867 156.266Z",
    fill: "url(#paint4_radial_5084_26628)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M163.907 156.262C163.901 157.572 162.803 158.63 161.453 158.624C160.106 158.619 159.018 157.551 159.023 156.239C159.029 154.929 160.128 153.871 161.477 153.877C162.825 153.883 163.913 154.95 163.907 156.262Z",
    fill: "url(#paint5_radial_5084_26628)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M168.036 163.646C168.196 161.826 166.809 160.225 164.937 160.069C163.065 159.914 161.418 161.263 161.257 163.082C161.097 164.902 162.485 166.503 164.357 166.659C166.229 166.815 167.876 165.466 168.036 163.646Z",
    fill: "url(#paint6_radial_5084_26628)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M167.089 163.378C167.083 164.687 165.985 165.745 164.635 165.74C163.288 165.734 162.199 164.666 162.205 163.354C162.211 162.044 163.31 160.986 164.659 160.992C166.007 160.998 167.095 162.066 167.089 163.378Z",
    fill: "url(#paint7_radial_5084_26628)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M173.081 158.024C174.41 156.732 174.41 154.639 173.081 153.347C171.753 152.056 169.599 152.056 168.271 153.347C166.942 154.639 166.942 156.732 168.271 158.024C169.599 159.315 171.753 159.315 173.081 158.024Z",
    fill: "url(#paint8_radial_5084_26628)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M173.117 155.697C173.111 157.007 172.013 158.065 170.663 158.059C169.315 158.053 168.227 156.986 168.233 155.674C168.239 154.364 169.337 153.306 170.687 153.312C172.034 153.317 173.123 154.385 173.117 155.697Z",
    fill: "url(#paint9_radial_5084_26628)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M179.981 159.606C180.141 157.786 178.753 156.185 176.882 156.029C175.01 155.874 173.362 157.223 173.202 159.042C173.042 160.862 174.43 162.463 176.302 162.619C178.173 162.774 179.821 161.426 179.981 159.606Z",
    fill: "url(#paint10_radial_5084_26628)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M176.728 161.698C178.074 161.626 179.106 160.507 179.032 159.198C178.958 157.889 177.807 156.886 176.46 156.958C175.114 157.03 174.082 158.149 174.156 159.458C174.23 160.767 175.381 161.77 176.728 161.698Z",
    fill: "url(#paint11_radial_5084_26628)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M182.448 152.434C182.609 150.615 181.221 149.013 179.349 148.858C177.477 148.702 175.83 150.051 175.67 151.87C175.51 153.69 176.897 155.291 178.769 155.447C180.641 155.603 182.288 154.254 182.448 152.434Z",
    fill: "url(#paint12_radial_5084_26628)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M181.505 152.167C181.499 153.477 180.401 154.535 179.051 154.529C177.704 154.523 176.615 153.455 176.621 152.143C176.627 150.833 177.726 149.776 179.075 149.781C180.423 149.787 181.511 150.855 181.505 152.167Z",
    fill: "url(#paint13_radial_5084_26628)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M186.924 158.708C187.476 156.963 186.468 155.113 184.672 154.576C182.876 154.04 180.973 155.02 180.421 156.766C179.869 158.512 180.878 160.362 182.674 160.898C184.47 161.434 186.373 160.454 186.924 158.708Z",
    fill: "url(#paint14_radial_5084_26628)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M186.116 157.752C186.11 159.062 185.012 160.12 183.662 160.114C182.314 160.108 181.226 159.04 181.232 157.728C181.238 156.418 182.336 155.36 183.686 155.366C185.033 155.372 186.122 156.44 186.116 157.752Z",
    fill: "url(#paint15_radial_5084_26628)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M193.652 152.737C193.83 150.919 192.459 149.304 190.589 149.131C188.718 148.957 187.058 150.291 186.879 152.109C186.701 153.927 188.072 155.541 189.942 155.714C191.813 155.888 193.473 154.555 193.652 152.737Z",
    fill: "url(#paint16_radial_5084_26628)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M192.707 152.434C192.701 153.744 191.603 154.802 190.254 154.796C188.906 154.791 187.818 153.723 187.824 152.411C187.829 151.101 188.928 150.043 190.277 150.049C191.625 150.055 192.713 151.122 192.707 152.434Z",
    fill: "url(#paint17_radial_5084_26628)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M194.925 161.303C195.924 159.741 195.446 157.703 193.858 156.751C192.27 155.798 190.173 156.292 189.175 157.854C188.177 159.416 188.655 161.454 190.243 162.406C191.831 163.359 193.927 162.865 194.925 161.303Z",
    fill: "url(#paint18_radial_5084_26628)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M194.422 159.007C194.727 160.281 193.91 161.57 192.598 161.884C191.287 162.199 189.977 161.42 189.672 160.144C189.367 158.87 190.184 157.582 191.496 157.267C192.807 156.953 194.117 157.732 194.422 159.007Z",
    fill: "url(#paint19_radial_5084_26628)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M203.445 150.279C202.542 148.66 200.521 148.118 198.931 149.068C197.34 150.017 196.783 152.099 197.686 153.717C198.589 155.336 200.61 155.878 202.2 154.928C203.791 153.979 204.348 151.897 203.445 150.279Z",
    fill: "url(#paint20_radial_5084_26628)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M201.208 149.641C202.471 149.986 203.209 151.321 202.854 152.624C202.5 153.925 201.187 154.7 199.922 154.355C198.659 154.01 197.922 152.675 198.276 151.372C198.631 150.071 199.943 149.296 201.208 149.641Z",
    fill: "url(#paint21_radial_5084_26628)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M143.582 152.729C152.823 152.771 155.909 160.022 165.15 160.066C174.393 160.108 175.015 153.117 183.664 154.216C198.298 158.553 199.463 158.165 202.567 153.505",
    stroke: "#337364",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M179.571 153.155L178.734 153.151L178.728 154.433L179.565 154.437L179.571 153.155Z",
    fill: "#337364"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M180.013 152.556C180.009 153.341 179.606 153.429 179.109 153.427C178.612 153.425 178.208 153.333 178.212 152.548C178.216 151.763 178.626 150.58 179.123 150.582C179.619 150.584 180.017 151.771 180.013 152.556Z",
    fill: "#F26B4B"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M171.599 156.464L170.938 156.78L171.845 158.569L172.506 158.252L171.599 156.464Z",
    fill: "#337364"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M171.757 155.714C172.116 156.418 171.793 156.672 171.348 156.886C170.903 157.099 170.499 157.192 170.143 156.488C169.785 155.783 169.608 154.549 170.056 154.333C170.501 154.12 171.401 155.008 171.759 155.712L171.757 155.714Z",
    fill: "#F0B28C"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M201.207 152.062L200.7 152.651L202.283 154.079L202.79 153.49L201.207 152.062Z",
    fill: "#337364"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M201.523 151.575C202.11 152.103 201.915 152.469 201.593 152.844C201.27 153.219 200.942 153.463 200.355 152.934C199.768 152.406 199.146 151.304 199.469 150.93C199.792 150.555 200.938 151.049 201.523 151.577L201.523 151.575Z",
    fill: "#F0B28C"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M156.665 157.526L156.021 157.21L155.244 158.706L155.889 159.022L156.665 157.526Z",
    fill: "#337364"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M155.998 159.756C156.362 159.054 156.043 158.798 155.6 158.581C155.157 158.363 154.755 158.267 154.391 158.967C154.027 159.669 153.839 160.902 154.282 161.12C154.725 161.337 155.636 160.458 156 159.756H155.998Z",
    fill: "#F0B28C"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M164.963 160.106L164.275 160.103L164.265 162.034L164.954 162.037L164.963 160.106Z",
    fill: "#337364"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M165.688 162.741C165.692 161.837 165.229 161.731 164.655 161.728C164.083 161.726 163.618 161.826 163.612 162.732C163.606 163.638 164.066 165.002 164.639 165.005C165.211 165.007 165.682 163.647 165.688 162.741Z",
    fill: "#F26B4B"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M161.44 157.572L160.847 157.41L160.309 159.269L160.902 159.431L161.44 157.572Z",
    fill: "#337364"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M162.358 157.098C162.107 157.969 161.63 157.946 161.078 157.796C160.525 157.646 160.108 157.423 160.359 156.551C160.611 155.68 161.438 154.489 161.99 154.641C162.542 154.791 162.607 156.226 162.356 157.098H162.358Z",
    fill: "#F26B4B"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M193.098 156.699L192.479 156.537L191.988 158.244L192.607 158.406L193.098 156.699Z",
    fill: "#337364"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M192.983 159.364C193.214 158.563 192.831 158.366 192.329 158.235C191.827 158.104 191.393 158.087 191.162 158.888C190.932 159.689 190.993 161.001 191.496 161.131C191.998 161.262 192.753 160.163 192.983 159.364Z",
    fill: "#F26B4B"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M176.07 156.024L175.264 156.256L175.867 158.236L176.674 158.003L176.07 156.024Z",
    fill: "#337364"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M177.551 158.474C177.286 157.606 176.811 157.635 176.263 157.793C175.713 157.95 175.299 158.177 175.562 159.045C175.828 159.913 176.671 161.092 177.221 160.934C177.771 160.776 177.816 159.339 177.553 158.472L177.551 158.474Z",
    fill: "#771119"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M151.932 152.831L151.319 152.641L150.715 154.481L151.328 154.671L151.932 152.831Z",
    fill: "#337364"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M152.95 152.415C152.667 153.277 152.192 153.239 151.646 153.069C151.1 152.9 150.691 152.663 150.974 151.802C151.256 150.94 152.125 149.778 152.671 149.947C153.218 150.117 153.233 151.553 152.95 152.415Z",
    fill: "#771119"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M184.405 154.312L183.555 154.212L183.164 157.364L184.015 157.463L184.405 154.312Z",
    fill: "#337364"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M184.855 157.119C184.966 156.22 184.519 156.065 183.949 155.997C183.381 155.93 182.906 155.98 182.795 156.878C182.685 157.777 182.977 159.185 183.545 159.252C184.113 159.319 184.743 158.019 184.855 157.121V157.119Z",
    fill: "#771119"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M190.711 152.574L190.054 152.341L188.866 155.507L189.523 155.74L190.711 152.574Z",
    fill: "#337364"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M191.18 153.089C190.861 153.939 190.388 153.881 189.85 153.691C189.312 153.5 188.912 153.248 189.231 152.398C189.549 151.548 190.467 150.423 191.006 150.613C191.544 150.804 191.498 152.241 191.18 153.091V153.089Z",
    fill: "#771119"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M151.383 151.957C151.298 152.171 151.167 152.323 151.094 152.296C151.021 152.269 151.031 152.073 151.116 151.857C151.201 151.644 151.332 151.492 151.405 151.519C151.478 151.546 151.468 151.742 151.383 151.957Z",
    fill: "#771119"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M175.992 158.677C176.026 158.904 175.99 159.098 175.911 159.11C175.834 159.121 175.743 158.945 175.709 158.718C175.676 158.491 175.711 158.296 175.79 158.285C175.867 158.273 175.959 158.45 175.992 158.677Z",
    fill: "#771119"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M183.427 156.786C183.399 157.015 183.312 157.192 183.233 157.182C183.153 157.172 183.114 156.98 183.142 156.751C183.169 156.522 183.256 156.345 183.336 156.355C183.415 156.364 183.454 156.557 183.427 156.786Z",
    fill: "#771119"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M189.733 152.542C189.602 152.734 189.444 152.856 189.379 152.813C189.314 152.771 189.365 152.58 189.496 152.39C189.626 152.198 189.785 152.076 189.85 152.119C189.915 152.161 189.864 152.352 189.733 152.542Z",
    fill: "#771119"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M160.779 156.734C160.694 156.947 160.563 157.099 160.49 157.072C160.417 157.045 160.426 156.849 160.512 156.634C160.597 156.42 160.727 156.268 160.8 156.295C160.874 156.322 160.864 156.518 160.779 156.734Z",
    fill: "#F26B4B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M164.137 162.565C164.052 162.778 163.921 162.93 163.848 162.903C163.775 162.876 163.785 162.68 163.87 162.465C163.955 162.251 164.085 162.099 164.159 162.126C164.232 162.153 164.222 162.349 164.137 162.565Z",
    fill: "#F26B4B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M178.685 152.203C178.6 152.417 178.469 152.569 178.396 152.542C178.323 152.515 178.333 152.319 178.418 152.103C178.503 151.89 178.634 151.738 178.707 151.765C178.78 151.792 178.77 151.988 178.685 152.203Z",
    fill: "#F26B4B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M191.682 158.998C191.582 159.208 191.443 159.353 191.372 159.321C191.301 159.289 191.322 159.093 191.424 158.882C191.523 158.672 191.663 158.527 191.734 158.559C191.805 158.591 191.783 158.787 191.682 158.998Z",
    fill: "#F26B4B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M154.793 159.233C154.707 159.446 154.577 159.598 154.504 159.571C154.43 159.544 154.44 159.348 154.525 159.133C154.611 158.919 154.741 158.767 154.814 158.794C154.888 158.821 154.878 159.017 154.793 159.233Z",
    fill: "#F0B28C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M170.722 156.403C170.839 156.603 170.879 156.795 170.811 156.834C170.742 156.872 170.592 156.741 170.475 156.541C170.358 156.341 170.319 156.149 170.386 156.11C170.453 156.072 170.606 156.203 170.722 156.403Z",
    fill: "#F0B28C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M200.745 152.672C200.899 152.846 200.977 153.029 200.919 153.083C200.861 153.137 200.69 153.038 200.537 152.866C200.383 152.692 200.305 152.509 200.363 152.455C200.421 152.401 200.592 152.5 200.745 152.672Z",
    fill: "#F0B28C"
  })))), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M241.093 128.647C241.093 133.904 240.736 139.076 240.03 144.132C239.665 146.788 239.207 149.42 238.656 152.014C238.625 152.193 238.587 152.363 238.548 152.542C238.431 153.086 238.307 153.614 238.191 154.15C237.71 156.223 237.166 158.273 236.569 160.308C235.032 165.565 233.123 170.675 230.856 175.575C230.049 177.322 229.219 179.039 228.319 180.724C226.324 184.529 224.12 188.218 221.714 191.751C201.519 221.455 167.455 240.978 128.836 240.978C95.5944 240.978 65.737 226.518 45.1699 203.547C42.6397 200.705 40.2415 197.739 37.9908 194.648C34.9251 190.439 32.1466 185.989 29.6785 181.361C27.4744 177.229 25.5263 172.935 23.8576 168.501C23.7179 168.136 23.5782 167.771 23.4463 167.398C22.8332 165.744 22.2666 164.066 21.7388 162.366C21.5681 161.876 21.4129 161.379 21.2654 160.882C21.1723 160.572 21.0869 160.269 21.0015 159.951C18.1221 150.018 16.5776 139.503 16.5776 128.647C16.5776 66.6142 66.8391 16.3232 128.836 16.3232C190.832 16.3232 241.093 66.6142 241.093 128.647Z",
    fill: "url(#paint22_linear_5084_26628)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M214.519 231.946C205.702 234.206 188.387 238.042 165.344 240.333C154.742 241.389 142.177 242.173 128.215 242.173C103.309 242.173 73.9173 239.696 43.1597 231.884C43.8427 227.061 44.5334 222.246 45.2164 217.424C47.9871 217.773 50.7579 218.107 53.5286 218.418C120.011 233.732 179.648 223.947 204.344 218.395C207.045 218.092 209.746 217.766 212.455 217.424C213.145 222.262 213.828 227.108 214.519 231.946Z",
    fill: "#330B00"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M128.16 299.578C99.3975 299.578 65.1085 296.526 29.3837 286.664C25.2548 285.522 22.8255 281.243 23.9664 277.112C25.1073 272.973 29.3837 270.55 33.5127 271.691C85.536 286.05 134.47 285.32 166.361 282.183C201.061 278.766 223.701 271.831 223.926 271.761C228.016 270.496 232.362 272.779 233.635 276.871C234.908 280.964 232.626 285.313 228.536 286.586C227.574 286.889 204.492 293.987 168.332 297.59C156.861 298.732 143.271 299.578 128.16 299.578Z",
    fill: "#A84D30"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M228.528 286.578C227.566 286.881 204.484 293.987 168.332 297.583C156.861 298.732 143.272 299.571 128.16 299.571C99.3975 299.571 65.1086 296.519 29.3838 286.656C25.2471 285.515 22.8256 281.236 23.9665 277.104C24.145 276.444 24.4089 275.823 24.7426 275.256C26.4733 272.282 30.0435 270.729 33.5127 271.684C85.536 286.043 134.47 285.313 166.361 282.175C201.061 278.758 223.701 271.824 223.926 271.754C227.442 270.659 231.152 272.204 232.929 275.264C233.224 275.761 233.457 276.297 233.635 276.864C234.908 280.956 232.626 285.305 228.528 286.578Z",
    fill: "#510B00"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M232.929 275.271C231.99 276.894 230.461 278.183 228.528 278.781C227.566 279.084 204.484 286.181 168.332 289.785C156.861 290.926 143.271 291.773 128.16 291.773C99.3974 291.773 65.1084 288.713 29.3836 278.851C27.3424 278.292 25.7203 276.964 24.7424 275.263C26.4732 272.289 30.0433 270.735 33.5126 271.691C85.5359 286.049 134.47 285.32 166.361 282.182C201.061 278.765 223.701 271.83 223.926 271.761C227.442 270.666 231.151 272.211 232.929 275.271Z",
    fill: "#9B2700"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M128.215 234.245C101.625 234.245 69.9359 231.418 36.9042 222.301C32.7753 221.159 30.346 216.881 31.4869 212.749C32.6278 208.618 36.9042 206.187 41.0332 207.329C133.073 232.738 215.582 207.655 216.405 207.399C220.495 206.117 224.849 208.408 226.122 212.508C227.395 216.601 225.113 220.958 221.015 222.231C220.123 222.511 198.764 229.081 165.344 232.412C154.742 233.468 142.177 234.245 128.215 234.245Z",
    fill: "#A84D30"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M221.015 222.231C220.123 222.511 198.764 229.081 165.344 232.412C154.743 233.468 142.177 234.245 128.215 234.245C101.625 234.245 69.9282 231.426 36.9043 222.301C32.7676 221.167 30.3461 216.888 31.487 212.749C31.6655 212.089 31.9294 211.476 32.2553 210.917C33.9783 207.935 37.5562 206.374 41.0255 207.329C133.065 232.738 215.575 207.663 216.397 207.406C219.921 206.304 223.646 207.849 225.416 210.924C225.703 211.414 225.936 211.942 226.114 212.509C227.387 216.601 225.105 220.958 221.015 222.231Z",
    fill: "#510B00"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M225.416 210.917C224.477 212.547 222.948 213.836 221.015 214.434C220.123 214.714 198.764 221.284 165.344 224.615C154.743 225.671 142.177 226.448 128.215 226.448C101.625 226.448 69.9282 223.621 36.9043 214.504C34.8554 213.945 33.2333 212.609 32.2554 210.909C33.9784 207.927 37.5563 206.366 41.0255 207.321C133.066 232.73 215.575 207.655 216.397 207.399C219.921 206.296 223.646 207.841 225.416 210.917Z",
    fill: "#9B2700"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M170.032 274.564C170.032 275.248 170.11 275.908 170.257 276.545C142.511 279.488 115.16 279.488 87.4064 276.545C87.5617 275.908 87.6315 275.256 87.6315 274.564C87.6315 270.161 84.4106 266.527 80.1963 265.867C80.9879 260.299 81.7796 254.731 82.579 249.163C82.8118 249.178 83.0446 249.186 83.2775 249.186C87.8255 249.186 91.5664 245.738 92.0321 241.304C116.503 243.843 140.617 243.866 165.08 241.366C165.577 245.769 169.31 249.186 173.835 249.186C174.254 249.186 174.673 249.155 175.077 249.101C175.869 254.692 176.676 260.283 177.467 265.867C173.253 266.527 170.032 270.169 170.032 274.564Z",
    fill: "#330B00"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M191.265 269.012C191.265 269.641 191.377 270.239 191.601 270.822C150.63 278.3 111.037 275.007 70.2877 272.32C70.8462 268.639 70.2877 269.641 70.2877 269.012C70.2877 264.989 65.5523 261.658 59.3713 261.052C60.5303 255.958 61.7017 250.871 62.8606 245.777C63.2095 245.793 63.546 245.8 63.8949 245.8C70.5743 245.8 76.0698 242.647 76.7428 238.594C112.46 245.707 147.851 245.723 183.999 238.648C184.735 242.671 190.205 245.8 196.847 245.8C197.47 245.8 198.069 245.769 198.667 245.723C199.838 250.833 201.009 255.95 202.168 261.052C195.987 261.658 191.252 264.982 191.252 269.012H191.265Z",
    fill: "#DC833A"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M191.588 271.071C191.588 271.7 191.701 272.305 191.925 272.888C151.03 280.405 110.655 280.405 69.627 272.888C69.8513 272.305 69.9635 271.7 69.9635 271.071C69.9635 267.025 65.2032 263.678 58.9849 263.072C60.1562 257.954 61.3276 252.837 62.499 247.711C62.848 247.727 63.1844 247.735 63.5333 247.735C70.2501 247.735 75.7706 244.566 76.456 240.489C112.648 247.642 148.239 247.657 184.286 240.544C185.021 244.59 190.529 247.735 197.208 247.735C197.832 247.735 198.442 247.704 199.04 247.657C200.212 252.798 201.396 257.939 202.567 263.072C196.349 263.678 191.588 267.025 191.588 271.071Z",
    fill: "#FFBC59"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4746 242.174C95.9208 247.26 113.504 247.811 130.776 247.811C148.048 247.811 165.095 247.283 182.279 242.228C184.086 246.282 189.981 249.202 196.897 249.287C197.42 251.586 197.944 253.877 198.467 256.175C198.903 258.086 199.339 259.988 199.775 261.891C193.457 263.157 189.096 266.807 189.096 271.07C189.096 271.218 189.096 271.365 189.108 271.505C169.643 275.574 150.029 276.203 130.776 276.203C111.523 276.203 91.9082 275.582 72.4432 271.505C72.4432 271.357 72.4557 271.218 72.4557 271.07C72.4557 266.807 68.0817 263.157 61.7761 261.891L64.6672 249.264C71.2843 248.969 76.7798 246.103 78.4871 242.182",
    stroke: "#AE1E39",
    strokeMiterlimit: 10
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M192.478 256.511L194.14 258.175L195.803 256.511L194.14 254.847L192.478 256.511Z",
    fill: "#510B00"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M65.97 256.512L67.6328 258.176L69.2957 256.512L67.6328 254.848L65.97 256.512Z",
    fill: "#510B00"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M108.287 268.007C108.747 267.547 108.747 266.803 108.287 266.343C107.828 265.884 107.084 265.884 106.625 266.343C106.165 266.803 106.165 267.547 106.625 268.007C107.084 268.466 107.828 268.466 108.287 268.007Z",
    fill: "#814900"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M100.047 261.338L99.6089 261.36C99.2874 261.36 99.1267 261.104 99.1267 260.592L99.2582 259.671C99.3167 259.408 99.4189 259.196 99.565 259.035C99.7696 258.83 99.9814 258.728 100.201 258.728C100.654 258.728 101.048 258.545 101.384 258.179C101.735 257.814 101.91 257.412 101.91 256.973C101.91 256.11 101.479 255.679 100.617 255.679C100.223 255.679 99.9011 255.803 99.6527 256.052C99.3459 256.359 99.0683 256.527 98.8199 256.556C98.4108 256.498 98.2063 256.176 98.2063 255.591C98.2063 253.836 99.3313 252.959 101.581 252.959C102.034 252.959 102.494 253.025 102.962 253.156C103.444 253.288 103.824 253.456 104.102 253.661C104.394 253.866 104.649 254.18 104.869 254.604C105.102 255.014 105.212 255.489 105.197 256.03C105.197 256.571 105.117 257.053 104.956 257.477C104.81 257.902 104.635 258.231 104.43 258.465C104.007 258.947 103.612 259.261 103.247 259.408L103.028 259.495C102.925 259.539 102.874 259.612 102.874 259.715L103.006 259.912C104.598 260.512 105.395 261.791 105.395 263.751C105.395 264.73 105.256 265.579 104.978 266.295C104.701 267.012 104.386 267.545 104.036 267.896C103.685 268.233 103.276 268.503 102.809 268.708C102.21 268.971 101.654 269.103 101.143 269.103C100.646 269.103 100.223 269.073 99.8719 269.015C99.5358 268.971 99.1852 268.869 98.8199 268.708C98.0894 268.372 97.7241 267.677 97.7241 266.624C97.7241 266.01 97.768 265.476 97.8556 265.023L97.9214 264.76C98.0382 264.263 98.2866 264.014 98.6665 264.014C98.8857 264.014 99.0683 264.102 99.2144 264.277C99.5212 264.701 99.9595 264.913 100.529 264.913C101.114 264.913 101.545 264.723 101.822 264.343C102.115 263.963 102.261 263.509 102.261 262.983C102.261 262.457 102.034 262.054 101.581 261.777C101.143 261.484 100.632 261.338 100.047 261.338Z",
    fill: "#814900"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M161.017 254.528L160.973 255.585C160.973 255.967 161.053 256.179 161.214 256.223C161.389 256.268 161.557 256.29 161.718 256.29C161.879 256.29 162.12 256.275 162.441 256.246C162.748 256.246 162.901 256.444 162.901 256.84C162.901 257.588 162.368 258.168 161.302 258.579C161.155 258.638 161.053 258.77 160.995 258.975C160.907 259.871 160.863 260.92 160.863 262.123C160.863 263.327 160.907 264.119 160.995 264.501C161.068 264.853 161.331 265.066 161.784 265.139C161.886 265.139 161.981 265.191 162.069 265.294C162.229 265.484 162.31 265.675 162.31 265.866C162.31 266.042 162.295 266.218 162.266 266.394C162.237 266.556 162.164 266.791 162.047 267.099C161.944 267.392 161.806 267.671 161.63 267.935C161.47 268.185 161.221 268.405 160.885 268.596C160.549 268.787 160.169 268.882 159.746 268.882C159.015 268.882 158.489 268.449 158.168 267.583C158.051 267.246 157.992 266.842 157.992 266.372L158.168 260.45C158.168 259.731 158.124 259.144 158.036 258.689C157.963 258.234 157.685 257.809 157.203 257.412C156.999 257.266 156.896 257.06 156.896 256.796C156.896 256.532 157.028 256.268 157.291 256.003C158.095 255.504 158.832 254.719 159.504 253.648C159.709 253.369 159.965 253.229 160.272 253.229C160.768 253.229 161.017 253.662 161.017 254.528Z",
    fill: "#814900"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M141.648 262.849L141.604 264.5C141.604 264.941 141.626 265.535 141.67 266.283L141.736 267.406C141.736 267.89 141.568 268.25 141.232 268.485C140.691 268.866 139.997 269.057 139.15 269.057C138.551 269.057 138.251 268.8 138.251 268.287L138.295 267.935C138.66 266.217 138.843 264.764 138.843 263.576C138.857 262.387 138.821 261.594 138.733 261.198C138.66 260.802 138.499 260.472 138.251 260.207C138.003 259.929 137.878 259.701 137.878 259.525C137.878 259.041 138.258 258.578 139.018 258.138C139.778 257.698 140.377 257.478 140.815 257.478C141.268 257.478 141.524 257.72 141.582 258.204C141.611 258.85 141.692 259.173 141.823 259.173C141.867 259.173 141.918 259.151 141.977 259.107C142.035 259.004 142.123 258.879 142.24 258.732C142.371 258.586 142.641 258.395 143.051 258.16C143.474 257.91 143.956 257.786 144.497 257.786C145.038 257.786 145.483 258.006 145.834 258.446C146.184 258.886 146.396 259.407 146.469 260.009C146.499 260.259 146.513 260.67 146.513 261.242L146.426 264.5C146.426 265.498 146.652 266.181 147.105 266.548C147.368 266.68 147.499 266.848 147.499 267.054C147.499 267.245 147.441 267.421 147.324 267.582C146.769 268.375 145.863 268.771 144.607 268.771C144.008 268.756 143.657 268.514 143.555 268.045C143.511 267.839 143.489 267.524 143.489 267.098C143.489 266.658 143.525 265.975 143.598 265.051C143.686 264.111 143.73 263.422 143.73 262.981C143.73 261.675 143.438 261.022 142.853 261.022C142.473 261.022 142.174 261.227 141.955 261.638C141.75 262.049 141.648 262.453 141.648 262.849Z",
    fill: "#814900"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M133.96 257.478C135.231 257.478 136.195 258.035 136.853 259.151C137.525 260.266 137.861 261.631 137.861 263.245C137.861 265.373 137.254 266.988 136.042 268.089C135.37 268.69 134.624 268.991 133.806 268.991C132.988 268.991 132.309 268.822 131.768 268.485C131.242 268.147 130.84 267.7 130.563 267.142C129.993 266.056 129.708 264.896 129.708 263.664C129.708 262.225 130.037 260.875 130.694 259.613C131.016 258.982 131.461 258.468 132.031 258.072C132.601 257.676 133.244 257.478 133.96 257.478ZM135.231 262.167C135.231 261.726 135.143 261.33 134.968 260.978C134.792 260.626 134.5 260.45 134.091 260.45C133.697 260.45 133.309 260.736 132.93 261.308C132.564 261.866 132.382 262.548 132.382 263.355C132.382 264.486 132.754 265.051 133.499 265.051C133.909 265.051 134.296 264.794 134.661 264.28C135.041 263.766 135.231 263.062 135.231 262.167Z",
    fill: "#814900"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M118.836 261.903L118.88 265.403L118.814 267.319C118.785 267.744 118.631 268.104 118.354 268.397C118.091 268.691 117.769 268.896 117.389 269.014C116.747 269.219 116.243 269.322 115.877 269.322C115.527 269.322 115.351 269.161 115.351 268.838L115.395 268.574C115.57 268.075 115.782 267.275 116.031 266.174L116.14 265.624C116.549 263.305 116.754 260.56 116.754 257.39C116.754 256.187 116.622 255.321 116.359 254.792C116.184 254.602 116.096 254.389 116.096 254.154C116.096 253.508 116.63 253.002 117.696 252.635C118.777 252.253 119.683 252.062 120.414 252.062C121.159 252.062 121.612 252.371 121.773 252.987C121.963 253.648 122.116 254.345 122.233 255.079C122.481 256.62 122.708 257.39 122.912 257.39C123.058 257.39 123.175 257.302 123.263 257.126C123.774 255.82 124.103 254.932 124.249 254.462C124.41 253.992 124.512 253.699 124.556 253.582C124.6 253.464 124.746 253.281 124.994 253.031C125.243 252.782 125.557 252.598 125.937 252.481C126.506 252.261 127.149 252.151 127.865 252.151C129.049 252.151 129.64 252.407 129.64 252.921C129.64 253.083 129.575 253.295 129.443 253.559C129.078 254.103 128.822 255.159 128.676 256.73C128.53 258.3 128.457 259.848 128.457 261.375C128.457 264.442 128.669 266.123 129.092 266.416C129.37 266.636 129.509 266.9 129.509 267.209C129.509 267.502 129.304 267.796 128.895 268.089C128.486 268.383 128.041 268.603 127.558 268.75C127.076 268.896 126.66 268.97 126.309 268.97C125.973 268.97 125.71 268.896 125.52 268.75C125.33 268.603 125.221 268.456 125.191 268.309L125.148 268.089C125.075 267.84 125.038 267.377 125.038 266.702C125.038 265.616 125.111 264.193 125.257 262.431L125.323 261.639C125.454 260.465 125.52 259.547 125.52 258.887C125.52 258.212 125.462 257.874 125.345 257.874C125.053 257.874 124.519 259.247 123.745 261.991C123.424 263.107 123.153 263.914 122.934 264.413L122.803 264.721C122.598 265.249 122.24 265.513 121.729 265.513C121.568 265.513 121.437 265.469 121.334 265.381C121.232 265.293 121.166 265.161 121.137 264.985C120.874 264.31 120.428 262.534 119.8 259.658L119.493 258.249C119.42 258.014 119.325 257.896 119.208 257.896C118.96 257.896 118.836 259.232 118.836 261.903Z",
    fill: "#814900"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M151.138 264.96C151.138 265.6 151.372 265.92 151.84 265.92C152.309 265.92 152.683 265.684 152.964 265.212C153.261 264.739 153.409 264.32 153.409 263.955C153.409 263.269 153.159 262.926 152.66 262.926C152.207 262.926 151.84 263.147 151.559 263.589C151.279 264.031 151.138 264.488 151.138 264.96ZM156.171 261.326L156.101 264.503C156.101 265.768 156.265 266.499 156.592 266.697C156.795 266.849 156.897 267.047 156.897 267.291C156.897 267.733 156.592 268.144 155.984 268.525C155.391 268.906 154.782 269.097 154.158 269.097C153.846 269.097 153.612 269.028 153.456 268.891C153.3 268.769 153.222 268.632 153.222 268.48C153.222 268.068 153.167 267.863 153.058 267.863C153.042 267.863 152.941 267.954 152.753 268.137C152.582 268.304 152.316 268.48 151.957 268.662C151.614 268.83 151.169 268.914 150.623 268.914C150.093 268.914 149.617 268.784 149.195 268.525C148.789 268.266 148.509 267.931 148.353 267.52C148.072 266.834 147.931 266.194 147.931 265.6C147.931 265.006 148.025 264.45 148.212 263.932C148.399 263.414 148.633 262.995 148.914 262.675C149.195 262.355 149.523 262.073 149.897 261.829C150.272 261.57 150.623 261.387 150.951 261.281C151.279 261.159 151.614 261.06 151.957 260.984C152.441 260.892 152.777 260.847 152.964 260.847L153.198 260.549C153.182 260.031 152.792 259.772 152.028 259.772C151.279 259.772 150.662 259.917 150.178 260.207C149.991 260.329 149.804 260.389 149.617 260.389C149.242 260.389 149.055 260.115 149.055 259.567C149.055 258.15 150.21 257.441 152.519 257.441C154.298 257.441 155.414 258.02 155.867 259.178C156.07 259.696 156.171 260.412 156.171 261.326Z",
    fill: "#814900"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M159.103 40.5677C161.646 40.5677 163.598 41.7037 164.96 43.9757C166.368 46.2476 167.071 48.7241 167.071 51.4051C167.071 54.086 166.822 56.4943 166.322 58.63C165.868 60.7657 164.915 62.6514 163.462 64.2872C162.054 65.8776 160.079 66.6728 157.537 66.6728C154.995 66.6728 153.088 65.5368 151.817 63.2648C150.545 60.9929 149.91 58.1529 149.91 54.7449C149.91 51.3369 150.681 48.1334 152.225 45.1344C153.769 42.0899 156.062 40.5677 159.103 40.5677ZM161.896 52.9727C161.896 51.0643 161.578 49.3148 160.942 47.7244C160.306 46.0886 159.467 45.2707 158.422 45.2707C156.516 45.2707 155.562 47.5427 155.562 52.0867C155.562 54.1769 155.88 55.7446 156.516 56.7897C157.197 57.8348 157.991 58.3574 158.899 58.3574C159.807 58.3574 160.533 57.9484 161.078 57.1305C161.623 56.2671 161.896 54.8812 161.896 52.9727ZM158.014 90.0516C157.514 91.1876 156.47 91.7556 154.881 91.7556C153.337 91.7556 152.566 91.3239 152.566 90.4606C152.566 90.1879 152.725 89.779 153.042 89.2337L181.917 40.1587C182.326 39.3862 183.279 39 184.778 39C186.276 39 187.025 39.409 187.025 40.2269C187.025 40.4541 186.957 40.704 186.821 40.9766L158.014 90.0516ZM181.032 65.1052C183.574 65.1052 185.527 66.2412 186.889 68.5131C188.296 70.7851 189 73.2616 189 75.9426C189 78.6235 188.75 81.0318 188.251 83.1675C187.797 85.3031 186.843 87.1889 185.391 88.8247C183.983 90.4151 182.008 91.2103 179.466 91.2103C176.923 91.2103 175.016 90.0743 173.745 87.8023C172.474 85.5303 171.838 82.6904 171.838 79.2824C171.838 75.8744 172.61 72.6709 174.154 69.6719C175.697 66.6274 177.99 65.1052 181.032 65.1052ZM183.824 77.5102C183.824 75.6017 183.506 73.8523 182.871 72.2619C182.235 70.6261 181.395 69.8082 180.351 69.8082C178.444 69.8082 177.491 72.0802 177.491 76.6241C177.491 78.7144 177.809 80.282 178.444 81.3272C179.125 82.3723 179.92 82.8948 180.828 82.8948C181.736 82.8948 182.462 82.4859 183.007 81.668C183.552 80.8046 183.824 79.4187 183.824 77.5102Z",
    fill: "#0537B6"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M132.601 64.628L128.174 65.2414C126.812 65.2414 126.131 64.6052 126.131 63.3329C126.131 54.6085 126.472 48.3378 127.153 44.5208C127.471 43.1122 128.038 42.2034 128.855 41.7945C129.672 41.3855 130.785 41.181 132.192 41.181L140.705 41.4537C142.294 41.4537 143.542 41.3173 144.45 41.0447C145.359 40.7721 145.903 40.6357 146.085 40.6357C147.038 40.6357 147.515 41.1583 147.515 42.2034C147.515 46.0658 146.721 48.5877 145.131 49.7691C144.45 50.4053 142.884 50.7234 140.432 50.7234L138.185 50.5871C136.369 50.5871 135.234 50.996 134.78 51.8139C134.462 52.541 134.303 53.5634 134.303 54.8811L134.371 56.1761C134.462 56.8577 134.803 57.1985 135.393 57.1985C135.847 57.1077 136.46 57.0622 137.232 57.0622C138.049 57.0622 138.866 57.1531 139.683 57.3349C140.546 57.5166 141.522 57.9483 142.612 58.6299C143.747 59.2661 144.7 60.1294 145.472 61.22C146.289 62.3105 146.97 63.9009 147.515 65.9911C148.105 68.0359 148.4 69.8762 148.4 71.5121C148.4 73.1479 148.355 74.3293 148.264 75.0564C148.219 75.738 148.06 76.8285 147.787 78.328C147.56 79.8276 147.106 81.2135 146.425 82.4858C145.744 83.7581 144.882 85.0531 143.838 86.3709C142.793 87.6432 141.363 88.6656 139.547 89.4381C137.731 90.1651 135.575 90.5286 133.078 90.5286C130.58 90.5286 128.356 89.8925 126.404 88.6202C124.905 87.6205 124.156 85.1213 124.156 81.1226C124.156 77.1239 125.155 75.1245 127.153 75.1245C127.516 75.1245 128.174 75.5108 129.128 76.2833C130.126 77.0103 131.33 77.3738 132.737 77.3738C133.69 77.3738 134.689 77.1239 135.733 76.6241C137.686 75.7153 138.662 73.7841 138.662 70.8305C138.662 68.2859 137.618 66.4455 135.529 65.3095C134.667 64.8552 133.69 64.628 132.601 64.628Z",
    fill: "#0537B6"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M121.958 45.1349C122.73 46.3617 123.116 47.7249 123.116 49.2244C123.116 50.6785 123.025 51.9054 122.843 52.9051C122.707 53.9047 122.367 54.9726 121.822 56.1086C121.322 57.2446 120.936 58.0625 120.664 58.5623C120.392 59.0622 119.779 60.0618 118.825 61.5613C117.917 63.0154 117.35 63.9242 117.123 64.2877L111.062 75.1933C110.789 75.8294 110.653 76.4429 110.653 77.0336C110.653 78.0333 111.402 78.5331 112.9 78.5331C114.444 78.5331 115.693 78.3286 116.646 77.9197C117.599 77.5107 118.235 77.1245 118.553 76.7609L119.03 76.1475C120.028 74.9206 120.959 74.3072 121.822 74.3072C123.093 74.3072 123.729 75.2614 123.729 77.1699C123.729 83.7132 122.752 87.7574 120.8 89.3023C120.028 90.2111 116.419 90.6655 109.972 90.6655L101.868 90.461C99.7342 90.3702 98.6672 89.3023 98.6672 87.2575C98.6672 84.304 100.143 80.2144 103.094 74.9888L109.7 62.7201C111.834 58.8577 112.9 55.8359 112.9 53.6548C112.9 52.5188 112.628 51.6555 112.083 51.0648C111.538 50.4286 110.994 50.0878 110.449 50.0424L109.632 49.906C108.678 49.906 107.816 50.156 107.044 50.6558C106.272 51.1556 105.75 51.6782 105.477 52.2235L105.001 52.9732C104.456 53.9729 103.639 54.4727 102.549 54.4727C101.232 54.4727 100.574 53.1777 100.574 50.5876C100.574 46.7253 101.664 44.0897 103.843 42.6811C106.068 41.227 108.951 40.5 112.492 40.5C116.941 40.5 120.096 42.045 121.958 45.1349Z",
    fill: "#0537B6"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8104 75.8743C93.9478 75.7834 91.587 75.7379 87.7279 75.7379L70.8387 75.8743C70.2485 75.8743 69.7945 75.6471 69.4767 75.1927C69.1589 74.6928 69 74.0794 69 73.3523C69 72.6253 69.2043 71.9437 69.6129 71.3076C70.0215 70.6714 70.6344 70.3306 71.4517 70.2852C78.6704 70.3306 84.1412 70.3533 87.8641 70.3533C91.587 70.3533 93.6754 70.3306 94.1294 70.2852C94.9467 70.3306 95.5823 70.6487 96.0363 71.2394C96.4903 71.8301 96.7173 72.489 96.7173 73.216C96.7173 73.9431 96.5357 74.5565 96.1725 75.0563C95.8547 75.5562 95.4007 75.8288 94.8104 75.8743Z",
    fill: "#0537B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.085 151.547) rotate(0.272183) scale(3.40164 3.30671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.083 151.548) rotate(0.272186) scale(2.4419 2.37375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.913 159.789) rotate(0.272186) scale(3.40164 3.30671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.913 159.788) rotate(0.272186) scale(2.4419 2.37375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.463 156.254) rotate(0.272186) scale(3.40164 3.30671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.463 156.253) rotate(0.272186) scale(2.4419 2.37375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.647 163.363) rotate(0.262464) scale(3.40164 3.30671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.645 163.367) rotate(0.272186) scale(2.4419 2.37375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.674 155.688) rotate(0.272191) scale(3.40164 3.30671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.674 155.688) rotate(0.272186) scale(2.4419 2.37375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(176.589 159.324) rotate(0.262465) scale(3.40164 3.30671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(176.593 159.324) rotate(0.262464) scale(2.4419 2.37375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.057 152.152) rotate(0.262463) scale(3.40164 3.30671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.06 152.159) rotate(0.272186) scale(2.4419 2.37375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.674 157.734) rotate(0.262471) scale(3.40164 3.30671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.673 157.744) rotate(0.272186) scale(2.4419 2.37375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(190.266 152.418) rotate(0.262465) scale(3.40164 3.30671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(190.265 152.427) rotate(0.272186) scale(2.4419 2.37375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.047 159.579) rotate(-13.461) scale(3.40184 3.30651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.046 159.581) rotate(-13.4584) scale(2.44226 2.37339)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.571 152.001) rotate(-74.7437) scale(3.40337 3.30503)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_5084_26628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.571 152.001) rotate(-74.7406) scale(2.44292 2.37277)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFEAA6",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFEAA6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEAA6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFEAA6",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEAA6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFEAA6",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFEAA6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFEAA6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEAA6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5084_26628",
    x1: 128.836,
    y1: 32.8815,
    x2: 128.836,
    y2: 210.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5084_26628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 309.076,
    fill: "white",
    transform: "translate(0 0.130859)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5084_26628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.0896,
    height: 10.0955,
    fill: "white",
    transform: "translate(166.866 171.755)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5084_26628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.7612,
    height: 20.9675,
    fill: "white",
    transform: "translate(144.358 146.904)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewYearDiscount3);
export default __webpack_public_path__ + "static/media/NewYearDiscount3.d75b7e7ad3e443d6327514b709f5b207.svg";
export { ForwardRef as ReactComponent };